(function() {
  'use strict';

  angular
    .module('playerfinder', ['ngAnimate', 'ngTouch', 'ngResource', 'ui.router', 'angular-md5', 'ngStorage', 'ngSanitize', 'ngCsv']);

})();

(function() {
  'use strict';

  angular
    .module('playerfinder')
    .controller('SettingsController', SettingsController);

  /** @ngInject */
  function SettingsController($http, $scope, API, APP_DEFAULTS, USER_DEFAULTS, $q, UserService, $timeout, $stateParams) {
    var vm = this;
    vm.ui = {
      api: API(),
      uploadError: false,
      teamError: false,
      tab: 'settings',
      appDefaults: APP_DEFAULTS,
      userDefaults: USER_DEFAULTS,
      showNewTeam: false,
      editError: false,
      edit: {
        profile: false,
        contact: false,
        tennis: false
      },
      editCopy: false
    };

    function init() {
      if ($stateParams.section && $stateParams.section !== '') {
        if ($stateParams.section === "team") {
          vm.setupNewTeam();
        }
        else if ($stateParams.section === "request") {
          vm.setupNewTeamProfile();
        }
      }
    }

    $timeout(init);

    vm.edit = function(type) {
      _.each(vm.ui.edit, function(param) {
        param = false;
      });

      vm.ui.edit[type] = true;
      vm.ui.editCopy = angular.copy($scope.main.user);
    };

    vm.saveProfilePhoto = function() {
      vm.ui.uploadError = false;

      // Make request
      var headers = {'Content-Type': undefined};
      $http({
        method: 'PUT',
        url: API() + 'users/photos/' + $scope.main.user.profile.userId, 
        headers: headers, 
        data: {
          files: vm.ui.newProfilePhoto
        },
        transformRequest: function (data, headersGetter) {
          var formData = new FormData();
          angular.forEach(data, function (value, key) {
            formData.append(key, value);
          });

          var headers = headersGetter();
          delete headers['Content-Type'];

          return formData;
        }
      }).then(function(res) {

        if (res.data && res.data.success && res.data.response) {

          // Set profile image
          $scope.main.user.profile.photo = res.data.response;
          vm.ui.uploadPhoto = false;
        } 
        else {
          vm.ui.uploadError = true;
        }
      }, function(err) {
        vm.ui.uploadError = true;
      });
    };

    vm.toggleNotifs = function(method) {
      if (!vm.ui.editCopy.settings.notificationMethods) {
        vm.ui.editCopy.settings.notificationMethods = {};
      }
      
      if (vm.ui.editCopy.settings.notificationMethods[method]) {
        delete vm.ui.editCopy.settings.notificationMethods[method];
      }
      else {
        vm.ui.editCopy.settings.notificationMethods[method] = true;
      }
    };

    vm.editTeam = function(team) {
      vm.ui.editTeam = angular.copy(team);
    };

    vm.editTeamProfile = function(profile) {
      vm.ui.editTeamProfile = angular.copy(profile);
    };  

    vm.saveTeamProfileUpdates = function() {
      vm.ui.teamError = false;
      $scope.main.ui.loading = true;

      // Swap edit team for current
      var cur = _.findIndex($scope.main.user.profile.teamProfiles, {profileId: vm.ui.editTeamProfile.profileId});
      if (cur < 0) {
        vm.ui.teamError = true;
        $scope.main.ui.loading = false;
        return;
      }

      vm.ui.editTeamProfile.updated = moment().valueOf();
      $scope.main.user.profile.teamProfiles[cur] = angular.copy(vm.ui.editTeamProfile);

      var params = {
        '$set': {
          'teamProfiles': $scope.main.user.profile.teamProfiles
        }
      };

      // Save
      $http.put(API() + 'users', {params: params}).then(function(res) {
        $scope.main.ui.loading = false;

        if (res.data && res.data.success && res.data.data) {

          // All good
          vm.ui.editTeamProfile = false;
        }
        else {
          vm.ui.teamError = true;
        }
      });
    };

    vm.saveTeamUpdates = function() {
      vm.ui.teamError = false;
      $scope.main.ui.loading = true;
      var params = {
        '$set': {}
      };

      _.each(vm.ui.editTeam, function(obj, key) {
        params.$set[key] = obj;
      });

      // Delete fields from params we don't need
      delete params.$set._id;

      // Add fields
      params.$set.updated = moment().valueOf();

      // Get Location
      getLocationFromZip(vm.ui.editTeam.facilityZip).then(function(location) {
        params.$set.location = {type: 'Point', coordinates: [location.lat, location.lng]};

        // Save
        $http.put(API() + 'teams/' + vm.ui.editTeam._id, params).then(function(res) {
          $scope.main.ui.loading = false;

          if (res.data && res.data.success && res.data.data) {

            // Update current
            var teamIndex = _.findIndex($scope.main.user.teams, {_id: vm.ui.editTeam._id});
            if (teamIndex > -1) {
              $scope.main.user.teams[teamIndex] = vm.ui.editTeam;
            }

            vm.ui.editTeam = false;
          }
          else {
            vm.ui.teamError = true;
          }
        });

      }, function() {
        console.log('error obtaining team location');
        vm.ui.teamError = true;
        $scope.main.ui.loading = false;
      });
    };

    vm.setupNewTeam = function() {
      vm.ui.showNewTeam = true; 
      vm.ui.newTeam = {
        createdBy: $scope.main.user.profile.userId,
        created: moment().valueOf(),
        expires: moment().add(6, 'months').endOf('day').valueOf()
      };

      // Set defaults
      vm.ui.newTeam.county = $scope.main.user.profile.county ? $scope.main.user.profile.county : false;
    };

    vm.setupNewTeamProfile = function() {
      vm.ui.showNewTeamProfile = true; 
      vm.ui.newTeamProfile = {
        created: moment().valueOf(),
        profileId: 'teamProfile_' + moment().valueOf()
      };

      // Set defaults
      vm.ui.newTeamProfile.county = $scope.main.user.profile.county ? $scope.main.user.profile.county : false;
      vm.ui.newTeamProfile.zip = $scope.main.user.profile.zip ? $scope.main.user.profile.zip : false;
    };

    vm.deleteTeamProfile = function() {
      if (!confirm('Are you sure you would like to delete this team profile? This action cannot be reversed')) { return; }

      // Remove by index
      var index = _.findIndex($scope.main.user.profile.teamProfiles, {profileId: vm.ui.editTeamProfile.profileId});
      if (index < 0) {
        return;
      }

      $scope.main.user.profile.teamProfiles.splice(index, 1);

      var params = {
        '$set': {
          teamProfiles: $scope.main.user.profile.teamProfiles
        }
      };

      // Delete
      $http.put(API() + 'users', {params: params}).then(function(res) {
        if (res.data && res.data.success && res.data.data) {

          // All good
          vm.ui.editTeamProfile = false;
        }
      });
    };

    vm.deleteTeam = function() {
      if (!confirm('Are you sure you would like to delete this team? This action cannot be reversed')) { return; }

      // Delete
      $http.delete(API() + 'teams/' + vm.ui.editTeam._id).then(function(res) {
        if (res.data && res.data.success && res.data.data) {

          // Update current
          var teamIndex = _.findIndex($scope.main.user.teams, {_id: vm.ui.editTeam._id});
          if (teamIndex > -1) {
            $scope.main.user.teams.splice(teamIndex, 1);
          }
          vm.ui.editTeam = false;
        }
      });
    };

    vm.saveNewTeam = function() {
      $scope.main.ui.loading = true;
      vm.ui.teamError = false;

      // Get zip code location
      getLocationFromZip(vm.ui.newTeam.facilityZip).then(function(location) {
        vm.ui.newTeam.location = {type: 'Point', coordinates: [location.lat, location.lng]};
        
        // Save
        $http.post(API() + 'teams', vm.ui.newTeam).then(function(res) {
          $scope.main.ui.loading = false;

          if (res.data && res.data.success && res.data.response) {

            // Update current
            vm.ui.showNewTeam = vm.ui.newTeam = false;
            $scope.main.user.teams.push(res.data.response);
          }
          else {
            vm.ui.teamError = true;
          }
        });

      }, function(err) {
        console.log('error obtaining location');
        vm.ui.teamError = true;
        $scope.main.ui.loading = false;
      });
    };

    vm.saveNewTeamProfile = function() {
      $scope.main.ui.loading = true;
      vm.ui.teamError = false;
      
      var params = {
        '$push': {
          'teamProfiles': vm.ui.newTeamProfile
        }
      };

      // Save
      $http.put(API() + 'users', {params: params}).then(function(res) {
        $scope.main.ui.loading = false;

        if (res.data && res.data.success && res.data.data) {

          // Update current
          if (!$scope.main.user.profile.teamProfiles) {
            $scope.main.user.profile.teamProfiles = [];
          }

          $scope.main.user.profile.teamProfiles.push(angular.copy(vm.ui.newTeamProfile));

          // Close
          vm.ui.showNewTeamProfile = vm.ui.newTeamProfile = false;
        }
        else {
          vm.ui.teamError = true;
        }
      });
    };

    vm.toggleDiscoverable = function(option) {
      var params = {
        '$set': {
          discoverable: option,
          discoverableExpires: option !== 'No' ? moment().add(6, 'months').valueOf() : false,
          lastUpdated: moment().valueOf()
        }
      };

      // Save
      $http.put(API() + 'users', {params: params}).then(function(res) {
        if (res.data && res.data.success && res.data.data) {

          // Update current
          $scope.main.user.profile.discoverable = option;
          $scope.main.user.profile.discoverableExpires = params.$set.discoverableExpires;
          $scope.main.user.profile.lastUpdated = moment().valueOf();
        }
      });
    };

    vm.toggleHitWith = function() {
      var newSelection = !$scope.main.user.profile.hitWith;
      var params = {
        '$set': {
          hitWith: newSelection,
          lastUpdated: moment().valueOf()
        }
      };

      // Save
      $http.put(API() + 'users', {params: params}).then(function(res) {
        if (res.data && res.data.success && res.data.data) {

          // Update current
          $scope.main.user.profile.hitWith = newSelection;
          $scope.main.user.profile.lastUpdated = moment().valueOf();
        }
      });
    };

    function getLocationFromZip(zip) {
      var defer = $q.defer();
      $http({
        method: 'GET', 
        url: vm.ui.appDefaults.geocode + zip, 
        headers: {
         'Content-Type': undefined,
         'x-access-token': undefined
       },
      }).then(function(res) {
        if (res.status === 200 && res.data && res.data.results.length > 0) {
          defer.resolve(res.data.results[0].geometry.location);
        }
        else {
          defer.reject();
        }
      });

      return defer.promise;
    }

    vm.saveUpdates = function() {
      vm.ui.editError = false;
      var params;
      var settings;
      var defer = $q.defer();

      if (vm.ui.edit.profile) {
        // Update user
        params = {
          $set: {
            fname: vm.ui.editCopy.profile.fname,
            lname: vm.ui.editCopy.profile.lname,
            about: vm.ui.editCopy.profile.about,
            lastUpdated: moment().valueOf()
          }
        };

        defer.resolve();
      }
      else if (vm.ui.edit.contact) {
        // Update user + notif settings
        params = {
          $set: {
            lastUpdated: moment().valueOf(),
            county: vm.ui.editCopy.profile.county,
            zip: vm.ui.editCopy.profile.zip,
            phone: vm.ui.editCopy.profile.phone,
            'settings.preferredContact': vm.ui.editCopy.settings.preferredContact,
            'settings.notificationMethods': vm.ui.editCopy.settings.notificationMethods
          }
        };

        // If zip code changed, let's change our location
        if (vm.ui.editCopy.profile.zip !== $scope.main.user.profile.zip) {

          getLocationFromZip(vm.ui.editCopy.profile.zip).then(function(location) {
            params.$set.location = {type: 'Point', coordinates: [location.lat, location.lng]};
            defer.resolve();

          }, function(err) {
            console.log('error obtaining location');
            defer.resolve();
          });
        }
        else {
          defer.resolve();
        }
      }
      else {
        // Update tennis + history settings
        params = {
          $set: {
            'settings.ustaNumber': vm.ui.editCopy.settings.ustaNumber,
            'settings.ustaLevel': vm.ui.editCopy.settings.ustaLevel,
            'settings.altaLevel': vm.ui.editCopy.settings.altaLevel,
            'settings.matchType': vm.ui.editCopy.settings.matchType,
            'settings.matchSide': vm.ui.editCopy.settings.matchSide,
            'settings.captain': vm.ui.editCopy.settings.captain,
            lastUpdated: moment().valueOf()
          }
        };

        defer.resolve();
      }

      // Save
      $q.when(defer.promise).then(function() {

        $http.put(API() + 'users', {params: params}).then(function(res) {
          if (res.data && res.data.success && res.data.data) {

            // Update current
            $scope.main.user.profile = vm.ui.editCopy.profile;
            $scope.main.user.settings = vm.ui.editCopy.settings;
            $scope.main.user.lastUpdated = moment().valueOf();

            // All set
            vm.ui.edit = {
              profile: false,
              contact: false,
              tennis: false
            };
          }
          else {
            vm.ui.editError = true;
          }
        });
      });
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('playerfinder')
    .controller('ListController', ListController);

  /** @ngInject */
  function ListController($timeout, $http, UserService, $location, API, $scope, APP_DEFAULTS, $state, $rootScope, $q) {
    var vm = this;

    vm.ui = {
      appDefaults: APP_DEFAULTS,
      api: API(),
      search: '',
      page: $state.current.name,
      type: 'player',
      selectedConnection: false,
      updateError: false
    };

    vm.data = {
      allTeams: {},
      allPlayers: {},
      player: [],
      team: []
    };

    if ($scope.main.ui.loaded) {
      console.log('already loaded');
      $timeout(init);
    }

    var _listener = $rootScope.$on('EVENTS.ALL_LOADED', init);

    $scope.$on('$destroy', function() {
      if (_listener) {
        _listener();
        _listener = null;
      }
    });

    function init() {
      // Check auth state
      if (!UserService.currentUser()) {
        $location.path('/auth');
        return;
      }

      // Populate
      if (vm.ui.page === 'favorites') {

        if ($scope.main.user.settings.favorites) {
          // Get favorite players
          getFavoritePlayers($scope.main.user.settings.favorites.player).then(function(favoritePlayers) {
            vm.data.player = favoritePlayers;
          });

          // Get favorite teams
          getFavoriteTeams($scope.main.user.settings.favorites.team).then(function(favoriteTeams) {
            vm.data.team = favoriteTeams;
          });
        }
        else {
          vm.data.player = [];
          vm.data.team = [];
        }
      }
      else if (vm.ui.page === 'connections') {
        getPlayerConnections($scope.main.user.connections).then(function(fullConnections) {
          getTeamConnections(fullConnections).then(function(allConnections) {
            vm.data.player = allConnections;
          });
        });

        // Check for state params
        if ($state.params.connectionId) {
          var conn = _.find($scope.main.user.connections, {_id: $state.params.connectionId});
          if (conn) {
            vm.selectConnection(conn);
          }
          else {
            vm.closeConnection();
          }
        }
      } 
    }

    function getFavoriteTeams(arr) {
      var defer = $q.defer();
      var promises = [];
      
      _.each(arr, function(teamId) {
        var promise = $q.defer();
        promises.push(promise.promise);

        // Check if we already have
        if (vm.data.allTeams[teamId]) {
          promise.resolve(vm.data.allTeams[teamId]);
        }
        else {
          // Fetch 
          UserService.fetchTeam(teamId).then(function(team) {
            vm.data.allTeams[teamId] = team;
            promise.resolve(team);
          }, function(err) {
            promise.resolve(false);
          });
        }
      });

      $q.all(promises).then(function(teams) {
        defer.resolve(teams);
      });

      return defer.promise;
    }

    function getFavoritePlayers(arr) {
      var defer = $q.defer();
      var promises = [];
      
      _.each(arr, function(playerId) {
        var promise = $q.defer();
        promises.push(promise.promise);

        // Check if we already have
        if (vm.data.allPlayers[playerId]) {
          promise.resolve(vm.data.allPlayers[playerId]);
        }
        else {
          // Fetch 
          UserService.fetchUser(playerId).then(function(user) {
            user.age = moment().diff(moment(user.dob), 'years');
            vm.data.allPlayers[playerId] = user;
            promise.resolve(user);
          }, function(err) {
            promise.resolve(false);
          });
        }
      });

      $q.all(promises).then(function(users) {
        defer.resolve(users);
      });

      return defer.promise;
    }

    function getPlayerConnections(arr) {
      var defer = $q.defer();
      var promises = [];

      _.each(arr, function(item) {
        var promise = $q.defer();
        promises.push(promise.promise);
        var userId = item.from === $scope.main.user.profile.userId ? item.to : item.from;
        
        // Check if we already have
        if (vm.data.allPlayers[userId]) {
          promise.resolve(vm.data.allPlayers[userId]);
        }
        else {
          // Fetch 
          UserService.fetchUser(userId).then(function(user) {
            user.age = moment().diff(moment(user.dob), 'years');
            vm.data.allPlayers[userId] = user;
            promise.resolve(user);
          }, function(err) {
            promise.resolve(false);
          });
        }
      });

      $q.all(promises).then(function(players) {
        
        _.each(arr, function(conn) {
          var key = conn.from === $scope.main.user.profile.userId ? 'to' : 'from';
          conn.fullPlayer = _.find(players, {_id: conn[key]});
        });

        defer.resolve(arr);
      });

      return defer.promise;
    }

    function getTeamConnections(arr) {
      var defer = $q.defer();
      var promises = [];

      _.each(arr, function(item) {
        var promise = $q.defer();
        promises.push(promise.promise);

        if (item.team) {
          // Check if we already have
          if (vm.data.allTeams[item.team]) {
            promise.resolve(vm.data.allTeams[item.team]);
          }
          else {
            // Fetch 
            UserService.fetchTeam(item.team).then(function(team) {
              vm.data.allTeams[item.team] = team;
              promise.resolve(team);
            }, function(err) {
              promise.resolve(false);
            });
          }
        }
        else {
          promise.resolve();
        }
      });

      $q.all(promises).then(function(teams) {
        
        _.each(arr, function(conn) {
          if (conn.team) {
            conn.fullTeam = _.find(teams, {_id: conn.team});
          }
        });

        defer.resolve(arr);
      });

      return defer.promise;
    }

    function updateConnectionStatus(connectionId, status) {
      var defer = $q.defer();
      // Update
      $http.put(API() + 'connections/' + connectionId, {$set: {status: status, updated: moment().valueOf()}}).success(function(res) {
        if (res.success && res.data) {
          defer.resolve();
        }
        else {
          // Throw error
          defer.reject();
        }
      });

      return defer.promise;
    }

    vm.removeFavorite = function(type, itemId) {
      var index = $scope.main.user.settings.favorites[type].indexOf(itemId);
      if (index > -1) {
        $scope.main.user.settings.favorites[type].splice(index, 1); 

        var params = {
          '$set': {
            'settings.favorites': $scope.main.user.settings.favorites
          }
        };

        // Save
        $http.put(API() + 'users', {params: params}).then(function(res) {
          if (res.data && res.data.success && res.data.data) {

            // Refresh list
            var findIndex = _.findIndex(vm.data[type], {_id: itemId});
            if (findIndex > -1) {
              vm.data[type].splice(findIndex, 1);
            }
          } 
        });
        }
    };

    vm.selectConnection = function(connection) {
      vm.ui.selectedConnection = connection;
      $state.go('connections', {connectionId: connection._id}, {notify: false, reload: false});
    };

    vm.closeConnection = function() {
      vm.ui.selectedConnection = false;
      $state.go('connections', {connectionId: null}, {notify: false, reload: false});
    };

    vm.approveConnection = function() {
      if (!confirm('Are you sure you would like to accept this connection? This will share your contact details and cannot be reversed.')) { return; }

      vm.ui.updateError = false;
      updateConnectionStatus(vm.ui.selectedConnection._id, 'Accepted').then(function() {
        // Update status
        vm.ui.selectedConnection.status = 'Accepted';
        vm.ui.selectedConnection.updated = moment().valueOf();
      }, function() {
        vm.ui.updateError = true;
      });
    };

    vm.rejectConnection = function() {
      if (!confirm('Are you sure you would like to reject this connection? This cannot be reversed.')) { return; }

      vm.ui.updateError = false;
      updateConnectionStatus(vm.ui.selectedConnection._id, 'Rejected').then(function() {
        // Update status
        vm.ui.selectedConnection.status = 'Rejected';
        vm.ui.selectedConnection.updated = moment().valueOf();
      }, function() {
        vm.ui.updateError = true;
      });
    };
  }

})();
(function() {
  'use strict';

  angular
    .module('playerfinder')
    .controller('InfoController', InfoController);

  /** @ngInject */
  function InfoController($timeout, $stateParams, MARKETING) {
    var vm = this;
    vm.ui = {
      copy: false,
      type: $stateParams.type
    };

    $timeout(init);

    function init() {
      if (vm.ui.type === 'contact') {
        vm.ui.copy = MARKETING.contact;
      }
      else if (vm.ui.type === 'about') {
        vm.ui.copy = MARKETING.about;
      }
      else if (vm.ui.type === 'privacy') {
        vm.ui.copy = MARKETING.privacy;
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('playerfinder')
    .controller('FeedController', FeedController);

  /** @ngInject */
  function FeedController($timeout, $http, UserService, $location, API, $scope, APP_DEFAULTS, $rootScope, $state, $window, $filter) {
    var vm = this;

    vm.ui = {
      appDefaults: APP_DEFAULTS,
      api: API(),
      search: '',
      view: 'grid',
      type: 'hit',
      limit: 500,
      selectedPlayer: false,
      selectedTeam: false,
      filters: {},
      adminFilterCount: 0,
      showAdminFilters: false,
      adminFilters: {},
      filterCount: 0,
      sort: APP_DEFAULTS.sorts[0],
      created: APP_DEFAULTS.created[0],
      direction: {key: 'asc', label: "Ascending"},
      pagination: {
        page: 1,
        numPages: 1
      },
      adminMode: 'players'
    };

    vm.data = {
      players: {
        hit: [],
        forTeam: []
      },
      teams: []
    };

    vm.adminData = {
      players: [],
      teams: [],
      selectedPlayers: {}
    };

    // Check if we're already loaded
    if ($scope.main.ui.loaded) {
      console.log('feed: already loaded');
      $timeout(init);
    }

    var _listener = $rootScope.$on('EVENTS.ALL_LOADED', init);

    $scope.$on('$destroy', function() {
      if (_listener) {
        _listener();
        _listener = null;
      }
    });

    function init() {

      // Check auth state
      if (!UserService.currentUser()) {
        $location.path('/auth');
        return;
      }

      console.log('feed: init');

      if (!$scope.main.user.profile.isAdmin) {
        compileInitialSearchAndFilters();
      }
      else {
        getAdminData();
        resetAdminFilters();
      }
    }

    function resetAdminFilters() {
      var defaults = {};

      // Setup admin filters
      vm.ui.adminFilters = {
        gender: {selected: defaults.gender ? defaults.gender : 'Any', available: vm.ui.appDefaults.genders, collapsed: true, label: 'Gender', show: {hit: true, players: true, teams: false}},
        age: {selected: defaults.age ? defaults.age : 'Any', available: _.pluck($scope.main.user.validAgeGroups, 'label'), collapsed: true, label: 'Age Group', show: {hit: true, players: true, teams: false}},
        level: {selected: defaults.level ? defaults.level : 'Any', available: vm.ui.appDefaults.altaLevels.all, collapsed: true, label: 'Level', show: {hit: true, players: true, teams: true}},
        county: {selected: defaults.county ? defaults.county : 'Any', available: vm.ui.appDefaults.counties, collapsed: true, label: 'County', show: {hit: true, players: true, teams: true}}
      };
    }

    vm.selectPlayer = function(e, player) {
      e.stopPropagation();
      e.preventDefault();

      if (vm.adminData.selectedPlayers[player._id]) {
        delete vm.adminData.selectedPlayers[player._id];
      }
      else {
        vm.adminData.selectedPlayers[player._id] = player;
      }
    };

    vm.connectPlayersEnabled = function() {
      return vm.ui.adminMode === "players" && Object.keys(vm.adminData.selectedPlayers).length === 2;
    }; 

    vm.playersSelected = function() {
      return vm.ui.adminMode === "players" && Object.keys(vm.adminData.selectedPlayers).length > 0;
    }; 

    vm.showMatch = function() {
      if (vm.connectPlayersEnabled()) {
        vm.ui.showAdminMatch = true;
      }
    };

    vm.createConnectionFromAdmin = function() {
      vm.ui.adminConnectResult = false;
      vm.ui.adminConnectResultError = false;
      $scope.main.ui.loading = true;

      var keys = Object.keys(vm.adminData.selectedPlayers);
      var fromUser = vm.adminData.selectedPlayers[keys[0]];
      var toUser = vm.adminData.selectedPlayers[keys[1]];
      
      var message = "Hello " + fromUser.fname + " and " + toUser.fname + "! We thought you two would be a good connection for each other - the plyrfndr team";
      var params = {
        from: fromUser._id,
        to: toUser._id,
        type: "hit",
        message: message,
        created: moment().valueOf(),
        body: "You have received a connection request from the plyrfndr team for: " + fromUser.fname + " <> " + toUser.fname,
        status: 'Pending Approval'
      };

      // Save
      $http.post(API() + 'connections', params).then(function(res) {
        $scope.main.ui.loading = false;

        if (res.data && res.data.success && res.data.response) {
          vm.ui.adminConnectResult = true;
          vm.adminData.selectedPlayers = {};
        }
        else {
          vm.ui.adminConnectResult = true;
          vm.ui.adminConnectResultError = true;
        } 
      }, function() {
        $scope.main.ui.loading = false;
        vm.ui.adminConnectResult = true;
        vm.ui.adminConnectResultError = true;
      });
    };

    vm.setAdminPage = function(page) {
      vm.ui.pagination.page = page;
      getAdminData();
    };

    vm.getCSV = function() {
      if (vm.ui.adminMode === "players") {
        var filtered;
        if (vm.playersSelected()) {
          filtered = Object.keys(vm.adminData.selectedPlayers).map(function(key) {
            return vm.adminData.selectedPlayers[key];
          });
        }
        else {
          filtered = $filter("filter")(vm.adminData.players, vm.ui.search);
        }

        return filtered.filter(function(player) {
          return player.fname !== undefined && player.lname !== undefined;
        }).map(function(player) {
          return {
            name: player.fname + " " + player.lname,
            age: player.age,
            gender: player.gender,
            level: player.settings && player.settings.ustaLevel ? player.settings.ustaLevel : "n/a",
            captain: player.settings && player.settings.captain ? player.settings.captain : "No",
            county: player.county,
            email: player.email,
            phone: player.phone,
            created: moment(parseInt(player.created)).format("MM/DD/YYYY")
          }
        });
      }

      var filteredTeams = $filter("filter")(vm.adminData.teams, vm.ui.search);
      return filteredTeams.map(function(team) {
        return {
          name: team.name,
          facility: team.facility,
          county: team.county,
          league: team.league,
          type: team.type,
          level: team.level,
          season: team.season,
          created: moment(parseInt(team.created)).format("MM/DD/YYYY")
        }
      });
    }

    vm.createNewTeam = function() {
      var path = "/settings/";
      path += vm.ui.type === "players" ? "request" : "team";
      $location.path(path);
    };

    vm.getAdminPlayers = function() {
      var filtered = $filter("filter")(vm.adminData.players, vm.ui.search).filter(function(p) { return p.fname; });
      vm.ui.adminNumResults = filtered.length;
      return filtered;
    };

    vm.getAdminTeams = function() {
      var filtered = $filter("filter")(vm.adminData.teams, vm.ui.search);
      vm.ui.adminNumResults = filtered.length;
      return filtered;
    };

    vm.getCSVHeader = function() {
      if (vm.ui.adminMode === "players") {
        return ['Name', 'Age', 'Gender', 'Level', 'Willing to Captain', 'County', 'Email', 'Phone', 'Created'];
      }

      return ['Name', 'Facility', 'County', 'League', 'Type', 'Level', 'Season', 'Created'];
    };

    vm.setAdminSort = function(sort) {
      vm.ui.showSort = false;

      if (vm.ui.sort.key === sort.key) { 
        return;
      }

      vm.ui.sort = sort;
      getAdminData();
    };

    vm.setAdminCreated = function(created) {
      vm.ui.showCreatedFilter = false;

      if (vm.ui.created.key === created.key) { 
        return;
      }

      // Reset search
      vm.ui.search = "";
      vm.ui.created = created;
      getAdminData();
    };

    vm.setAdminSortDirection = function(dir) {
      vm.ui.showSortDirection = false;

      if (vm.ui.direction.key === dir.key) {
        return;
      }

      vm.ui.direction = dir;
      getAdminData();
    };

    vm.setAdminMode = function(mode) {
      if (vm.ui.adminMode === mode) { return; }

      // Reset sort
      vm.ui.sort = mode === 'teams' ? {key: 'created', label: 'Created'} : {key: 'fname', label: 'Name'};

      // Reset filters
      resetAdminFilters();
      vm.ui.adminFilterCount = 0;

      if (mode === "teams") {
        vm.ui.direction = {label: 'Descending', key: 'desc'};
      }
      else {
        vm.ui.direction = {label: 'Ascending', key: 'asc'};
      }

      // Reset search
      vm.ui.search = "";
      vm.ui.adminMode = mode;
      vm.ui.pagination.page = 1;
      getAdminData();
    };

    function getAdminData() {
      $window.scrollTo(0,0);

      // Set sort
      var sort = {};
      sort[vm.ui.sort.key] = vm.ui.direction.key === "asc" ? 1 : -1;
      if (vm.ui.sort.key === 'dob') {
        sort[vm.ui.sort.key] = -1 * sort[vm.ui.sort.key];
      }

      // Get users or teams
      var path = vm.ui.adminMode === 'players' ? 'fetchusers' : 'fetchteams';
      var createdSixMonths = moment().subtract(6, "months").valueOf();
      
      // Teams created is stored numerically, players by string...eek, I know
      var createdSearch = vm.ui.adminMode === 'players' ? createdSixMonths.toString() : createdSixMonths;

      // Make our search
      var search = vm.ui.created.key === "createdAll" ? {} : {"created": {"$gte": createdSearch}};

      // Filters
      _.each(vm.ui.adminFilters, function(filter, key) {
        if (filter.selected !== 'Any') {
          if (key !== 'age' && key !== 'distance' && key !== 'season' && key !== 'level') {
            search[key] = {$in: filter.selected};
          }
          else if (key === 'level') {

            // conform filter / map to easy options
            var updatedLevel = refineLevelFilter(filter.selected);
            search['settings.ustaLevel'] = {$in: updatedLevel};
          }
          else if (key === 'age') {
            var ageGroup = _.find($scope.main.user.validAgeGroups, {label: filter.selected[0]});
            var time = moment().subtract(ageGroup.amount, 'years').startOf('year').valueOf();
            if ($scope.main.user.settings.agePreference === 'junior') {
              // Create gt 
              search.dob = {$gte: time};
            }
            else {
              // Create lt 
              search.dob = {$lte: time};
            }
          }
        }
      });

      console.log(search);

      // Go
      $http.post(API() + path, {search: search, sort: sort, page: vm.ui.pagination.page}).success(function(res) {
        if (res.success && res.response) {

          // Set pagination first time only
          if (vm.ui.pagination.page === 1) {
            vm.ui.pagination.numPages = Math.ceil(res.count/1000);
            vm.ui.pagination.numResults = res.count;

            var pages = [];
            for (var i = 0; i < vm.ui.pagination.numPages; i++) {
              pages.push({label: "Page " + (i+1), page: (i+1)});
            }

            vm.ui.pagination.pages = pages;
          }

          _.each(res.response, function(item) {
            // Set age on players
            if (vm.ui.adminMode === 'players' && item.dob) {
              item.age = moment().diff(moment(item.dob), 'years');
            }
          });

          vm.adminData[vm.ui.adminMode] = res.response;
        }
        else {
          // Throw error
          vm.adminData[vm.ui.adminMode] = [];
        }
      });
    }

    vm.adminEditPlayer = function(player) {
      vm.ui.adminViewPlayer = angular.copy(player);

      // Set birthday
      vm.ui.adminViewPlayer.birthday = new Date(moment(player.dob).format('MM/DD/YYYY'));
    };

    vm.adminEditTeam = function(team) {
      vm.ui.adminViewTeam = angular.copy(team);
    };

    vm.deletePlayer = function() {
      if (!confirm('Are you sure you would like to delete this player? This action cannot be reversed.')) { return; }

      $http.delete(API() + 'users/' + vm.ui.adminViewPlayer._id).then(function(res) {
        if (res.data && res.data.success && res.data.data) {

          // Update current
          var playerIndex = _.findIndex(vm.adminData.players, {_id: vm.ui.adminViewPlayer._id});
          if (playerIndex > -1) {
            vm.adminData.players.splice(playerIndex, 1);
          }

          // All set
          vm.ui.adminViewPlayer = false;
        }
        else {
          vm.ui.adminError = true;
        }
      });
    };

    vm.deleteTeam = function() {
      if (!confirm('Are you sure you would like to delete this team? This action cannot be reversed.')) { return; }

      $http.delete(API() + 'teams/' + vm.ui.adminViewTeam._id + '/adminDelete').then(function(res) {
        if (res.data && res.data.success && res.data.data) {

          // Update current
          var teamIndex = _.findIndex(vm.adminData.teams, {_id: vm.ui.adminViewTeam._id});
          if (teamIndex > -1) {
            vm.adminData.teams.splice(teamIndex, 1);
          }

          // All set
          vm.ui.adminViewTeam = false;
        }
        else {
          vm.ui.adminError = true;
        }
      });
    };

    vm.makeTeamUpdates = function() {
      if (!vm.ui.adminViewTeam) { return; }

      vm.ui.adminError = false;
      var params = {
        $set: {
          name: vm.ui.adminViewTeam.name,
          about: vm.ui.adminViewTeam.about,
          lastUpdated: moment().valueOf(),
          facility: vm.ui.adminViewTeam.facility,
          county: vm.ui.adminViewTeam.county,
          league: vm.ui.adminViewTeam.league,
          type: vm.ui.adminViewTeam.type,
          level: vm.ui.adminViewTeam.level,
          season: vm.ui.adminViewTeam.season
        }
      };

      $http.put(API() + 'teams/' + vm.ui.adminViewTeam._id, params).then(function(res) {
        if (res.data && res.data.success && res.data.data) {

          // Update current
          var teamIndex = _.findIndex(vm.adminData.teams, {_id: vm.ui.adminViewTeam._id});
          if (teamIndex > -1) {
            _.each(params.$set, function(val, key) {
              vm.adminData.teams[teamIndex][key] = val;
            });
          }

          // All set
          vm.ui.adminViewTeam = false;
        }
        else {
          vm.ui.adminError = true;
        }
      });
    };

    vm.makePlayerUpdates = function() {
      if (!vm.ui.adminViewPlayer) { return; }

      vm.ui.adminError = false;
      var params = {
        $set: {
          fname: vm.ui.adminViewPlayer.fname,
          lname: vm.ui.adminViewPlayer.lname,
          about: vm.ui.adminViewPlayer.about,
          lastUpdated: moment().valueOf(),
          county: vm.ui.adminViewPlayer.county,
          zip: vm.ui.adminViewPlayer.zip,
          email: vm.ui.adminViewPlayer.email,
          phone: vm.ui.adminViewPlayer.phone,
          'settings.ustaNumber': vm.ui.adminViewPlayer.settings.ustaNumber,
          'settings.ustaLevel': vm.ui.adminViewPlayer.settings.ustaLevel,
          'settings.altaLevel': vm.ui.adminViewPlayer.settings.altaLevel,
          'settings.captain': vm.ui.adminViewPlayer.settings.captain
        }
      };

      // See if birthday has changed
      if (vm.ui.adminViewPlayer.birthday) {
        var newVal = moment(vm.ui.adminViewPlayer.birthday).valueOf();
        if (newVal !== vm.ui.adminViewPlayer.dob) {
          params.$set.dob = newVal;
        }
      }

      $http.put(API() + 'users/' + vm.ui.adminViewPlayer._id, {params: params}).then(function(res) {
        if (res.data && res.data.success && res.data.data) {

          // Update current
          var playerIndex = _.findIndex(vm.adminData.players, {_id: vm.ui.adminViewPlayer._id});
          if (playerIndex > -1) {
            if (!vm.adminData.players[playerIndex].settings) { vm.adminData.players[playerIndex].settings = {}; }

            _.each(params.$set, function(val, key) {
              if (key.indexOf('settings') > -1) {
                var split = key.split('settings.');
                var newKey = split[1];
                vm.adminData.players[playerIndex].settings[newKey] = val;
              }
              else {
                vm.adminData.players[playerIndex][key] = val;

                if (key === "dob") {
                  console.log("Update dob");
                  vm.adminData.players[playerIndex].age =  moment().diff(moment(val), 'years');
                }
              }
            });
          }

          // All set
          vm.ui.adminViewPlayer = false;
        }
        else {
          vm.ui.adminError = true;
        }
      });
    };

    function refineLevelFilter(selectedValues) {
      // We need to set up the following rules for level filters:
      // -- Beginner should include Beginner, 2.5 and 3.0
      // -- Intermediate should include Intermediate, 3.5 and 4.0
      // -- Advanced should include Advanced, 4.5 and 5.0
      var selected = JSON.parse(JSON.stringify(selectedValues));
      if (selected.indexOf("Beginner") > -1) {
        if (selected.indexOf("2.5") < 0) {
          selected.push("2.5");
        }
        if (selected.indexOf("3.0") < 0) {
          selected.push("3.0");
        }
      }

      if (selected.indexOf("Intermediate") > -1) {
        if (selected.indexOf("3.5") < 0) {
          selected.push("3.5");
        }
        if (selected.indexOf("4.0") < 0) {
          selected.push("4.0");
        }
      }

      if (selected.indexOf("Advanced") > -1) {
        if (selected.indexOf("4.5") < 0) {
          selected.push("4.5");
        }
        if (selected.indexOf("5.0") < 0) {
          selected.push("5.0");
        }
      }

      return selected;
    }

    function compileInitialSearchAndFilters() {

      // Setup initial filters
      var defaults = {};

      if ($scope.main.user.settings.lastSearch) {
        vm.ui.type = $scope.main.user.settings.lastSearch.type;
        vm.ui.sort = $scope.main.user.settings.lastSearch.sort ? $scope.main.user.settings.lastSearch.sort : vm.ui.appDefaults.sorts[0];
        _.each($scope.main.user.settings.lastSearch.filters, function(val, key) {
          defaults[key] = val;
        });
      }
      else {
        defaults = {
          age: 'Any',
          gender: [$scope.main.user.profile.gender]
        };
      }

      vm.ui.filters = {
        type: {selected: defaults.type ? defaults.type : 'Any', available: vm.ui.appDefaults.teamTypes[$scope.main.user.settings.agePreference === 'junior' ? 'junior' : 'adult'], collapsed: false, label: 'Type', show: {hit: false, players: false, teams: true}},
        league: {selected: defaults.league ? defaults.league : 'Any', available: vm.ui.appDefaults.leagues[$scope.main.user.settings.agePreference === 'junior' ? 'junior' : 'adult'], collapsed: false, label: 'League', show: {hit: false, players: false, teams: true}},
        gender: {selected: defaults.gender ? defaults.gender : 'Any', available: vm.ui.appDefaults.genders, collapsed: false, label: 'Gender', show: {hit: true, players: true, teams: false}},
        age: {selected: defaults.age ? defaults.age : 'Any', available: _.pluck($scope.main.user.validAgeGroups, 'label'), collapsed: false, label: 'Age Group', show: {hit: true, players: true, teams: false}},
        level: {selected: defaults.level ? defaults.level : 'Any', available: vm.ui.appDefaults.altaLevels[$scope.main.user.settings.agePreference === 'junior' ? 'junior' : 'all'], collapsed: true, label: 'Level', show: {hit: true, players: true, teams: true}},
        season: {selected: defaults.season ? defaults.season : 'Any', available: vm.ui.appDefaults.availableSeasons, collapsed: true, label: 'Season', show: {hit: false, players: true, teams: true}},
        county: {selected: defaults.county ? defaults.county : 'Any', available: vm.ui.appDefaults.counties, collapsed: true, label: 'County', show: {hit: true, players: true, teams: true}},
        distance: {selected: defaults.distance ? defaults.distance : 'Any', available: vm.ui.appDefaults.distance, collapsed: true, label: 'Distance from me', show: {hit: true, players: true, teams: true}}
      };

      // Search
      doSearch();
    }

    vm.setType = function(type) {
      // Close
      vm.ui.showTypes = false;

      // Set type
      vm.ui.type = type;

      // Do search
      doSearch();
    };

    vm.createConnection = function() {
      vm.ui.connectResult = false;
      vm.ui.connectResultError = false;
      $scope.main.ui.loading = true;

      var item = vm.ui.selectedTeam ? vm.ui.selectedTeam : vm.ui.selectedPlayer;
      var isTeam = vm.ui.selectedTeam ? true : false;
      var params = {
        from: $scope.main.user.profile.userId,
        to: isTeam ? item.createdBy : item._id,
        type: vm.ui.type === 'hit' ? 'hit' : 'team',
        message: vm.ui.connectMessage,
        created: moment().valueOf(),
        body: "You have received a connection request from " + $scope.main.user.profile.fname,
        status: 'Pending Approval'
      };

      // Set team if applicable
      if (vm.ui.type === 'players' && vm.ui.connectTeam) {
        params.team = vm.ui.connectTeam._id;
        params.body += ' for the team, ' + vm.ui.connectTeam.name;
        params.fromTeam = true;
      }
      else if (vm.ui.type === 'teams') {
        params.team = item._id;
        params.body += ' for your team, ' + item.name;
      }

      // Save
      $http.post(API() + 'connections', params).then(function(res) {
        $scope.main.ui.loading = false;

        if (res.data && res.data.success && res.data.response) {
          vm.ui.connectResult = true;

          // Insert connection
          $scope.main.user.connections.push(res.data.response);
        }
        else {
          vm.ui.connectResult = true;
          vm.ui.connectResultError = true;
        } 
      }, function() {
        $scope.main.ui.loading = false;
        vm.ui.connectResult = true;
        vm.ui.connectResultError = true;
      });
    };

    vm.toggleFavorite = function(type, item) {
      if (!$scope.main.user.settings.favorites) {
        $scope.main.user.settings.favorites = {
          player: [],
          team: []
        };
      }

      var index = $scope.main.user.settings.favorites[type].indexOf(item._id);
      if (index > -1) {
        $scope.main.user.settings.favorites[type].splice(index, 1);
      }
      else {
        $scope.main.user.settings.favorites[type].push(item._id);
      }

      var params = {
        '$set': {
          'settings.favorites': $scope.main.user.settings.favorites
        }
      };

      // Save
      $http.put(API() + 'users', {params: params}).then(function(res) {
        if (res.data && res.data.success && res.data.data) {

          // All set
        }
      });
    };

    vm.viewConnection = function(playerId) {
      var type = vm.ui.type === 'hit' ? 'hit' : 'team';

      // Get connection
      var filtered = _.filter($scope.main.user.connections, function(conn) { return conn.type === type && (conn.from === playerId || conn.to === playerId); });
      if (filtered.length > 0) {
        $state.go('connections', {connectionId: filtered[0]._id});
      }
    };

    vm.viewSettings = function() {
      $state.go('settings');
    };

    vm.setAgePreference = function(pref) {
      var params = {
        '$set': {
          'settings.agePreference': pref,
        }
      };

      // Save
      $http.put(API() + 'users', {params: params}).then(function(res) {
        if (res.data && res.data.success && res.data.data) {

          // Update current
          $scope.main.user.settings.agePreference = pref;
          $scope.main.user.validAgeGroups = pref === 'junior' ? APP_DEFAULTS.ageGroups.junior : APP_DEFAULTS.ageGroups.adult; 

          // Clear last search
          UserService.saveUserSetting('lastSearch', false);
          $scope.main.user.settings.lastSearch = false;

          // Init
          init();
        }
      });
    };

    vm.clearAllFilters = function() {
      _.each(vm.ui.filters, function(filter) {
        filter.selected = 'Any';
      });

      vm.ui.filterCount = 0;

      // Search
      doSearch();
    };

    vm.toggleFilter = function(filter, val, key) {
      // Set value
      if (val === 'Any') {
        filter.selected = val;
      }
      else {
        if (key === 'age' || key === 'distance') {
          filter.selected = [val];
        }
        else {
          if (!angular.isArray(filter.selected)) {
            filter.selected = [val];
          }
          else {
            var index = filter.selected.indexOf(val);
            if (index > -1) {
              filter.selected.splice(index, 1);
            }
            else {
              filter.selected.push(val);
            }

            // Check if filter selected array is empty
            if (filter.selected.length < 1) {
              filter.selected = 'Any';
            }
          }
        }
      }

      // Search
      doSearch();
    };

    vm.cancelAdminFilters = function() {
      vm.ui.showAdminFilters = false;
      vm.ui.adminFilterCount = 0;
      resetAdminFilters();
      getAdminData();
    };

    vm.saveAdminFilters = function() {
      vm.ui.showAdminFilters = false;
      getAdminData();
    };
    
    vm.toggleAdminFilter = function(filter, val, key) {
      // Set value
      if (val === 'Any') {
        filter.selected = val;
      }
      else {
        if (key === 'age' || key === 'distance') {
          filter.selected = [val];
        }
        else {
          if (!angular.isArray(filter.selected)) {
            filter.selected = [val];
          }
          else {
            var index = filter.selected.indexOf(val);
            if (index > -1) {
              filter.selected.splice(index, 1);
            }
            else {
              filter.selected.push(val);
            }

            // Check if filter selected array is empty
            if (filter.selected.length < 1) {
              filter.selected = 'Any';
            }
          }
        }
      }

      // Set filter count
      var filtered = _.filter(vm.ui.adminFilters, function(item) { return item.selected !== 'Any'; });
      vm.ui.adminFilterCount = filtered.length;
    };

    vm.setSort = function(sort) {
      // Reset page
      vm.ui.pagination = {
        numPages: 0,
        page: 1
      };

      // Set
      vm.ui.sort = sort;
      vm.ui.showSort = false;

      // Search
      doSearch();
    };

    function doSearch() {
      // Set filter count
      var filtered = _.filter(vm.ui.filters, function(item) { return item.selected !== 'Any'; });
      vm.ui.filterCount = filtered.length;

      // Set params
      var params = {};

      if (vm.ui.type !== 'teams') {
        // Make sure we have hitWith
        if (vm.ui.type === 'hit') {
          params.hitWith = {$exists: true};
        }

        // Non Team Search
        _.each(vm.ui.filters, function(filter, key) {
          if (filter.selected !== 'Any') {
            if (key !== 'age' && key !== 'distance' && key !== 'season' && key !== 'level') {
              params[key] = {$in: filter.selected};
            }
            else if (key === 'level') {

              // refine
              var refinedLevels = refineLevelFilter(filter.selected);
              params['settings.ustaLevel'] = {$in: refinedLevels};
            }
            else if (key === 'distance') {
              var distance = filter.selected[0] === 'Less than 1 mile away' ? 1 : filter.selected[0] === 'Less than 5 miles away' ? 5 : filter.selected[0] === 'Less than 10 miles away' ? 10 : 20;
              params.location = {$geoWithin: {$centerSphere: [$scope.main.user.profile.location.coordinates, vm.ui.appDefaults.milesToRadian(distance)]}};
            }
            else if (key === 'age') {
              var ageGroup = _.find($scope.main.user.validAgeGroups, {label: filter.selected[0]});
              var time = moment().subtract(ageGroup.amount, 'years').startOf('year').valueOf();
              if ($scope.main.user.settings.agePreference === 'junior') {
                // Create gt 
                params.dob = {$gte: time};
              }
              else {
                // Create lt 
                params.dob = {$lte: time};
              }
            }
            else if (key === 'season' && vm.ui.type === 'players') {
              params.discoverable = {$in: filter.selected};
              params.discoverableExpires = {$gte: moment().valueOf()};
            }
          }
          else if (filter.selected === 'Any' && key === 'age') {
            // Intercept age
            var op = $scope.main.user.settings.agePreference === 'junior' ? '$gte' : '$lte';
            var dobSearch = {};
            dobSearch[op] = moment().subtract(18, 'years').valueOf();
            params.dob = dobSearch;
          }
          else if (filter.selected === 'Any' && key === 'season' && vm.ui.type === 'players') {
            // Intercept season
            params.discoverable = {$in: vm.ui.appDefaults.availableSeasons};
            params.discoverableExpires = {$gte: moment().valueOf()};
          }
        });
      }
      else {
        // Team search
        _.each(vm.ui.filters, function(filter, key) {
          if (filter.selected !== 'Any' && key !== 'gender' && key !== 'distance') {
            params[key] = {$in: filter.selected};
          }
          else if (filter.selected !== 'Any' && key === 'distance') {
            var teamDistance = filter.selected[0] === 'Less than 1 mile away' ? 1 : filter.selected[0] === 'Less than 5 miles away' ? 5 : filter.selected[0] === 'Less than 10 miles away' ? 10 : 20;
            params.location = {$geoWithin: {$centerSphere: [$scope.main.user.profile.location.coordinates, vm.ui.appDefaults.milesToRadian(teamDistance)]}};
          }
          // Handle all type
          else if (filter.selected === 'Any' && key === 'type') {
            params.type = {$in: vm.ui.appDefaults.teamTypes[$scope.main.user.settings.agePreference]};
          }
          // Handle all league
          else if (filter.selected === 'Any' && key === 'league') {
            params.league = {$in: vm.ui.appDefaults.leagues[$scope.main.user.settings.agePreference]};
          }
        });
      }

      // Let's persist this search
      var persist = {
        type: vm.ui.type,
        sort: vm.ui.sort,
        filters: {}
      };

      _.each(vm.ui.filters, function(filter, key) {
        persist.filters[key] = filter.selected;
      });

      console.log(params);
      UserService.saveUserSetting('lastSearch', persist);
      
      // Update current
      $scope.main.user.settings.lastSearch = persist;

      // Sort
      var sort = {};
      sort[vm.ui.sort.key] = vm.ui.sort.key === 'location' ? -1 : 1;

      // Search
      if (vm.ui.type === 'teams') {
        // Addtl --> We're going to let people see their own teams now
        // params.createdBy = {$ne: $scope.main.user.profile.userId};

        $http.post(API() + 'fetchteams', {search: params, sort: sort, page: vm.ui.pagination.page}).success(function(res) {
          if (res.success && res.response) {

            // Set pagination
            vm.ui.pagination.numPages = Math.ceil(res.count/1000);

            vm.data.teams = res.response;
          }
          else {
            // Throw error
            vm.data.teams = [];
          }
        });
      }
      else {

        $http.post(API() + 'fetchusers', {search: params, sort: sort, page: vm.ui.pagination.page}).success(function(res) {
          if (res.success && res.response) {

            // Set pagination
            vm.ui.pagination.numPages = Math.ceil(res.count/1000);

            var players = res.response;

            // Set age on players
            _.each(players, function(player) {
              player.age = moment().diff(moment(player.dob), 'years');
            });

            vm.data.players[vm.ui.type] = players;
          }
          else {
            // Throw error
            vm.data.players[vm.ui.type] = [];
          }
        });
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('playerfinder')
    .factory('UserService', ['$timeout', '$q', '$rootScope', '$http', '$localStorage', 'API', UserService]);

  /** @ngInject */
  function UserService($timeout, $q, $rootScope, $http, $localStorage, API) {
    var methods = {};

    methods.saveUserSetting = function(setting, value) {
      var defer = $q.defer();

      var params = {
        '$set': {}
      };

      params.$set['settings.' + setting] = value;

      // Save
      $http.put(API() + 'users', {params: params}).then(function(res) {
        if (res.data && res.data.success && res.data.data) {

          // Resolve
          defer.resolve();
        }
        else {
          defer.reject();
        }
      });

      return defer.promise;
    };

    methods.currentUser = function() {
      if ($localStorage.playerFinderCurrentUser) {
        return $localStorage.playerFinderCurrentUser;
      }

      return false;
    };

    methods.fetchUser = function(userId) {
      var defer = $q.defer();

      $http.get(API() + 'fetchuser/' + userId).then(function(res) {
        if (res.data && res.data.success && res.data.response) {
          defer.resolve(res.data.response);
        }
        else {
          defer.reject();
        }
      }, function(err) {
        defer.reject();
      });

      return defer.promise;
    };

    methods.fetchTeam = function(teamId) {
      var defer = $q.defer();

      $http.get(API() + 'teams/' + teamId).then(function(res) {
        if (res.data && res.data.success && res.data.data) {
          defer.resolve(res.data.data);
        }
        else {
          defer.reject();
        }
      }, function(err) {
        defer.reject();
      });

      return defer.promise;
    };

    methods.createNewCoppaAccount = function(params) {
      var defer = $q.defer();

      $http.post(API() + 'users', params).then(function(res) {
        if (res.data && res.data.success && res.data.response) {
          defer.resolve(res.data.response);
        }
        else {
          defer.reject();
        }
      }, function(err) {
        defer.reject();
      });

      return defer.promise;
    };

    methods.createNewAccount = function(params) {
      var defer = $q.defer();

      $http.post(API() + 'users', params).then(function(res) {
        if (res.data && res.data.success && res.data.response && res.data.token) {
          _saveUserData(res.data.token);
          $rootScope.$emit('EVENTS.AUTH_CHANGED');
          defer.resolve(res);
        }
        else {
          defer.reject();
        }
      }, function(err) {
        defer.reject();
      });

      return defer.promise;
    };

    methods.getCoppaAccount = function(hash) {
      var defer = $q.defer();

      $http.get(API() + 'verifycoppa/' + hash).then(function(res) {
        if (res.data && res.data.success && res.data.data) {
          defer.resolve(res.data.data);
        }
        else {
          defer.reject();
        }
      }, function(err) {
        defer.reject();
      });

      return defer.promise;
    };

    methods.updateCoppaAccount = function(hash, params) {
      var defer = $q.defer();

      $http.put(API() + 'verifycoppa/' + hash, params).then(function(res) {
        if (res.data && res.data.success && res.data.data) {
          defer.resolve();
        }
        else {
          defer.reject();
        }
      }, function(err) {
        defer.reject();
      });

      return defer.promise;
    };

    methods.login = function(params) {
      var defer = $q.defer();

      $http.post(API() + 'users/auth', params).then(function(res) {
        if (res.data && res.data.success && res.data.response && res.data.token) {
          _saveUserData(res.data.token);
          $rootScope.$emit('EVENTS.AUTH_CHANGED');
          defer.resolve(true);
        }
        else {
          defer.reject();
        }
      }, function(err) {
        defer.reject();
      });

      return defer.promise;
    };

    methods.forgot = function(params) {
      var defer = $q.defer();

      $http.post(API() + 'users/forgot', params).then(function(res) {
        if (res.data && res.data.success && res.data.response) {
          defer.resolve(true);
        }
        else {
          defer.reject();
        }
      }, function(err) {
        defer.reject();
      });

      return defer.promise;
    };

    methods.resetPassword = function(params) {
      var defer = $q.defer();

      $http.post(API() + 'users/reset', params).then(function(res) {
        if (res.data && res.data.success && res.data.response) {
          defer.resolve(true);
        }
        else {
          defer.reject();
        }
      }, function(err) {
        defer.reject();
      });

      return defer.promise;
    };

    methods.logout = function() {
      delete $localStorage.playerFinderCurrentUser;
      $http.defaults.headers.common['x-access-token'] = '';
      $timeout(function() {
        $rootScope.$emit('EVENTS.AUTH_CHANGED');
      });
    };

    function _saveUserData(token) {
      $localStorage.playerFinderCurrentUser = {token: token};
      $http.defaults.headers.common['x-access-token'] = token;
    }

    return methods;
  }
})();
(function() {
  'use strict';

  angular
    .module('playerfinder')
    .filter('phoneNumberFilter', PhoneNumberFilter)
    .directive('phoneDirective', ['$filter', PhoneDirective]);

  /** @ngInject */
  function PhoneDirective($filter) {
    return {
      restrict: 'E',
      scope: {
        phonenumberModel: '=model',
        isValid: '='
      },
      link: function link(scope, element, attributes) {

        scope.inputValue = scope.phonenumberModel;

        scope.$watch('inputValue', function(value, oldValue) {
          var stringValue = String(value);
          var number = stringValue.replace(/[^0-9]+/g, '');
          scope.phonenumberModel = number;
          scope.inputValue = $filter('phoneNumberFilter')(number);
          scope.isValid = number.length === 10;
        });
      },
      template: '<input ng-model="inputValue" type="tel" class="phonenumber" placeholder="Enter a phone number..." title="Phonenumber (Format: (999) 9999-9999)">'
    };
  }

  function PhoneNumberFilter() {
    return function(number) {
      if (!number) { return ''; }
      number = String(number);

      var formattedNumber = number;

      var c = (number[0] == '1') ? '1 ' : '';
      number = number[0] == '1' ? number.slice(1) : number;

      var area = number.substring(0,3);
      var front = number.substring(3, 6);
      var end = number.substring(6, 10);

      if (front) {
        formattedNumber = (c + "(" + area + ") " + front);  
      }
      if (end) {
        formattedNumber += ("-" + end);
      }
      return formattedNumber;
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('playerfinder')
    .controller('MainController', ['$timeout', '$rootScope', '$scope', 'UserService', '$http', 'API', 'USER_DEFAULTS', 'APP_DEFAULTS', '$q', '$interval', MainController]);

  /** @ngInject */
  function MainController($timeout, $rootScope, $scope, UserService, $http, API, USER_DEFAULTS, APP_DEFAULTS, $q, $interval) {
    var main = this;
    main.ui = {
      loading: true,
      loaded: false
    };

    main.user = {
      profile: false,
      settings: {},
      notifications: []
    };


    var _watch = $rootScope.$on('EVENTS.AUTH_CHANGED', onAuthChange);

    // Check for new notifications every 2min
    var _poller = $interval(refreshNotifications, 120000);

    // Initial
    onAuthChange();

    function refreshNotifications() {
      console.log('main: refreshNotifications');
      var user = UserService.currentUser();
      if (user) {
        $http.get(API() + 'users/settings').then(function(res) {

          if (res && res.data && res.data.success && res.data.data) {
            main.user.notifications = _.filter(res.data.data.notifications, function(notif) { return !notif.cleared; });
            main.user.connections = res.data.data.connections;
          }
        });
      }
    }

    function onAuthChange() {
      main.ui.loaded = false;
      main.ui.loading = true;
      console.log('main: onAuthChange');
      var today = moment();
      var user = UserService.currentUser();

      if (user) {
        // Get settings + notifs
        $http.get(API() + 'users/settings').then(function(res) {

          if (res && res.data && res.data.success && res.data.data) {
            main.user.profile = res.data.data.profile;
            main.user.settings = Object.keys(res.data.data.settings).length > 0 ? res.data.data.settings : USER_DEFAULTS;
            main.user.notifications = _.filter(res.data.data.notifications, function(notif) { return !notif.cleared; });
            main.user.connections = res.data.data.connections;
            main.user.teams = res.data.data.teams;
            main.user.isJunior = calculateJuniorStatus(main.user.profile.dob);

            // Set default age preference if we don't have it
            main.user.settings.agePreference = main.user.settings.agePreference ? main.user.settings.agePreference : main.user.isJunior ? 'junior' : 'adult';
            main.user.validAgeGroups = main.user.settings.agePreference === 'junior' ? APP_DEFAULTS.ageGroups.junior : APP_DEFAULTS.ageGroups.adult; 

            // Check if we need to dispatch notification about discoverable/discoverableExpires
            if (main.user.profile.discoverable && main.user.profile.discoverableExpires && moment(parseInt(main.user.profile.discoverableExpires)).diff(today, 'days') < 7) {
              var params = {
                subject: 'Your plyrfndr profile is expiring soon',
                from: false,
                to: main.user.profile.userId,
                created: moment().valueOf(),
                body: "Your plyrfndr profile is set to auto-expire soon (players will no longer be able to find you.) Please login and renew your profile under the Teams & Play tab. Thanks!",
                action: false,
                renewNotifExpires: main.user.profile.discoverableExpires
              };

              $http.post(API() + 'notifications', params).then(function(res) {});
            }

            console.log(main.user);
            main.ui.loading = false;
            main.ui.loaded = true;
            console.log("dispatch");
            $scope.$emit('EVENTS.ALL_LOADED');
          }
        });
      }
      else {
        main.user.profile = false;
        main.user.notifications = [];
        main.user.connections = [];
        main.user.teams = [];
        main.user.settings = {};
        main.ui.loading = false;
        main.ui.loaded = true;
        $scope.$emit('EVENTS.ALL_LOADED');
      }
    }

    function calculateJuniorStatus(dob) {
      // We'll calculate based on August 31, Current Year - 18 years
      var today = moment();
      var year = today.subtract(18, 'years').year();
      var cutoff = moment('August 31, ' + year);
      return dob > cutoff;
    }

    function calculateAgeGroups(junior, dob) {
      var age = moment().diff(moment(parseInt(dob)), 'years');
      var ageGroups = [];
      var groups = junior ? APP_DEFAULTS.ageGroups.junior : APP_DEFAULTS.ageGroups.adult;

      if (junior) {
        _.each(groups, function(group) {
          // var cutoff = moment(group.date + ', ' + (moment().year() - group.amount));

          // if (dob <= cutoff) {
            // ageGroups.push(group);
          // }
          if (age <= group.high) {
            ageGroups.push(group);
          }
        });
      }
      else {
        _.each(groups, function(group) {
          if (age <= group.high) {
            ageGroups.push(group);
          }
        });
      }

      return ageGroups;
    }

    $scope.$on('$destroy', function() {
      if (_watch) {
        _watch();
        _watch = null;
      }

      if (_poller) {
        _poller();
        _poller = null;
      }
    }); 
  }

})();

(function() {
  'use strict';

  angular
    .module('playerfinder')
    .directive('ustaHeader', ustaHeader);

  /** @ngInject */
  function ustaHeader(UserService, $timeout, $state, API, $q, $http, APP_DEFAULTS, $window, $rootScope) {
    return {
      restrict: 'E',
      templateUrl: 'app/components/header.template.html',
      link: function(scope, el) {
        scope.ui = {
          api: API(),
          appDefaults: APP_DEFAULTS,
          showUserMenu: false,
          showMail: false,
          showOnboarding: false,
          onboardingIndex: 0,
          onboardingError: false,
          onboardingSlides: [
            {
              title: "Welcome, {name}!",
              body: "Let's help you find teams and players around you by learning how to use plyrfndr.",
              nextButton: "Get started",
              next: function() { scope.ui.onboardingIndex++ },
              showLogo: true
            },
            {
              title: "Complete your profile",
              body: "Add a profile photo, name and bio to let people know who you are",
              nextButton: "Save",
              next: function() { scope.saveProfile() },
              allowSkip: true,
              profileForm: true
            },
            {
              title: "Play settings",
              body: "Set your play and visibility preferences - this will make it easier for other players and teams to match with you",
              nextButton: "Save",
              next: function() { scope.savePlay() },
              allowSkip: true,
              playForm: true
            },
            {
              title: "Notification settings",
              body: "If someone wants to connect with you or we need to send you any important info, what's the best way to reach you? Select all that apply",
              nextButton: "Save",
              next: function() { scope.saveNotifs() },
              allowSkip: true,
              notifForm: true
            },
            {
              title: "Your account management page",
              body: "This page contains a few more settings -- but don't worry, we just finished going through all of the really important ones. Take a look though - as you will find the ability to create teams and requests on this page. As always, we're here if you need help.",
              nextButton: "Next",
              next: function() { scope.onOnboardingSkipClick() }
            },
            {
              title: "All set!",
              body: "We hope you found this section helpful! Come back at any time to make changes. Have fun using plyrfndr!",
              nextButton: "Done",
              next: function() { scope.closeOnboarding() }
            }
          ]
        };

        // Let's determine if we need to show onboarding
        var _watch = $rootScope.$on('EVENTS.START_ONBOARDING', onLoad);
        function onLoad() {
          if (scope.main.user && scope.main.user.profile && scope.main.user.settings) {
            if (!scope.main.user.settings.hasOnboarded) {
              scope.showOnboarding();
              scope.saveOnboarding();
            }
          }
        }

        function makeNotificationUpdate(notif) {
          var defer = $q.defer();

          $http.put(API() + 'notifications/' + notif, {$set: {cleared: true}}).then(function(res) {
            if (res.data && res.data.success && res.data.data) {
              defer.resolve();
            }
            else {
              defer.reject();
            } 
          }, function() {
            defer.reject();
          });

          return defer.promise;
        }

        scope.onOnboardingSkipClick = function() {
          if (scope.ui.onboardingIndex < scope.ui.onboardingSlides.length) {
            scope.ui.onboardingIndex++;
          }
          else {
            scope.closeOnboarding();
          }
        };

        scope.saveProfile = function() {

          // Check if we need to save a photo
          var defer = $q.defer();
          var promise = defer.promise;
          if (scope.ui.newProfilePhoto) {
            promise = saveProfilePhoto();
          }
          else {
            defer.resolve();
          }

          $q.when(promise).then(function() {

            // Check what we want to change
            var params = {};

            if (scope.ui.onboardingUser.fname.length > 3 && scope.ui.onboardingUser.fname !== scope.main.user.profile.fname) {
              params.fname = scope.ui.onboardingUser.fname;
            }

            if (scope.ui.onboardingUser.lname.length > 3 && scope.ui.onboardingUser.lname !== scope.main.user.profile.lname) {
              params.lname = scope.ui.onboardingUser.lname;
            }

            if (scope.ui.onboardingUser.about !== scope.main.user.profile.about) {
              params.about = scope.ui.onboardingUser.about;
            }

            if (Object.keys(params).length < 1) {
              scope.ui.onboardingIndex++;
              return;
            }

            // Save
            params.lastUpdated = moment().valueOf();
            console.log(params);

            var dbParams = {
              $set: {}
            };

            Object.keys(params).forEach(function(key) {
              dbParams.$set[key] = params[key];
            });

            scope.ui.onboardingError = false;

            $http.put(API() + 'users', {params: dbParams}).then(function(res) {
              if (res.data && res.data.success && res.data.data) {

                // Update current
                Object.keys(params).forEach(function(key) {
                  scope.main.user.profile[key] = scope.ui.onboardingUser[key];
                });

                // Next
                scope.ui.onboardingIndex++;
              }
              else {
                scope.ui.onboardingError = "Uh oh! There was an error updating your profile. Please try again";
              }
            });
          }, function() {
            scope.ui.onboardingError = "Uh oh! There was an error updating your profile. Please try again";
          });
        };

        scope.savePlay = function() {

          // Check what we want to change
          var params = {};

          if (scope.ui.onboardingUserSettings.ustaNumber && scope.ui.onboardingUserSettings.ustaNumber.length > 2 && scope.ui.onboardingUserSettings.ustaNumber !== scope.main.user.settings.ustaNumber) {
            params.ustaNumber = scope.ui.onboardingUserSettings.ustaNumber;
          }

          if (scope.ui.onboardingUserSettings.ustaLevel !== scope.main.user.settings.ustaLevel) {
            params.ustaLevel = scope.ui.onboardingUserSettings.ustaLevel;
          }

          if (scope.ui.onboardingUserSettings.altaLevel !== scope.main.user.settings.altaLevel) {
            params.altaLevel = scope.ui.onboardingUserSettings.altaLevel;
          }

          if (scope.ui.onboardingUserSettings.matchType !== scope.main.user.settings.matchType) {
            params.matchType = scope.ui.onboardingUserSettings.matchType;
          }

          if (scope.ui.onboardingUserSettings.matchSide !== scope.main.user.settings.matchSide) {
            params.matchSide = scope.ui.onboardingUserSettings.matchSide;
          }

          if (scope.ui.onboardingUserSettings.captain !== scope.main.user.settings.captain) {
            params.captain = scope.ui.onboardingUserSettings.captain;
          }

          if (scope.ui.onboardingUser.discoverable !== scope.main.user.profile.discoverable) {
            params.discoverable = scope.ui.onboardingUser.discoverable;
            params.discoverableExpires = scope.ui.onboardingUser.discoverable !== 'No' ? moment().add(6, 'months').valueOf() : false;
          }

          if (scope.ui.onboardingUser.hitWith !== scope.main.user.profile.hitWith) {
            params.hitWith = scope.ui.onboardingUser.hitWith;
          }

          if (Object.keys(params).length < 1) {
            scope.ui.onboardingIndex++;
            return;
          }

          // Save
          console.log(params);

          var dbParams = {
            $set: {}
          };

          Object.keys(params).forEach(function(key) {
            var fullKey = key !== "hitWith" && key !== "discoverable" && key !== "discoverableExpires" ? "settings." + key : key;
            dbParams.$set[fullKey] = params[key];
          });

          scope.ui.onboardingError = false;

          $http.put(API() + 'users', {params: dbParams}).then(function(res) {
            if (res.data && res.data.success && res.data.data) {

              // Update current
              Object.keys(params).forEach(function(key) {
                if (key !== "hitWith" && key !== "discoverable" && key !== "discoverableExpires") {
                  scope.main.user.settings[key] = scope.ui.onboardingUserSettings[key];
                }
                else {
                  scope.main.user.profile[key] = scope.ui.onboardingUser[key];
                }
              });

              // Next
              scope.ui.onboardingIndex++;
            }
            else {
              scope.ui.onboardingError = "Uh oh! There was an error updating your preferences. Please try again";
            }
          });
        };

        scope.saveOnboarding = function() {

          var dbParams = {
            $set: {
              "settings.hasOnboarded": true
            }
          };

          $http.put(API() + 'users', {params: dbParams}).then(function(res) {
            if (res.data && res.data.success && res.data.data) {
              scope.main.user.settings.hasOnboarded = true;
            }
          });
        };

        scope.toggleNotifs = function(method) {
          if (!scope.ui.onboardingUserSettings.notificationMethods) {
            scope.ui.onboardingUserSettings.notificationMethods = {};
          }
          
          if (scope.ui.onboardingUserSettings.notificationMethods[method]) {
            delete scope.ui.onboardingUserSettings.notificationMethods[method];
          }
          else {
            scope.ui.onboardingUserSettings.notificationMethods[method] = true;
          }
        };

        scope.saveNotifs = function() {

          // Check what we want to change
          var params = {};
          params.notificationMethods = scope.ui.onboardingUserSettings.notificationMethods;

          // Save
          console.log(params);

          var dbParams = {
            $set: {}
          };

          Object.keys(params).forEach(function(key) {
            dbParams.$set["settings." + key] = params[key];
          });

          scope.ui.onboardingError = false;

          $http.put(API() + 'users', {params: dbParams}).then(function(res) {
            if (res.data && res.data.success && res.data.data) {

              // Update current
              Object.keys(params).forEach(function(key) {
                scope.main.user.settings[key] = scope.ui.onboardingUserSettings[key];
              });

              // Next
              scope.ui.onboardingIndex++;
            }
            else {
              scope.ui.onboardingError = "Uh oh! There was an error updating your notification settings. Please try again";
            }
          });
        };

        function saveProfilePhoto() {
          var defer = $q.defer();
    
          // Make request
          var headers = {'Content-Type': undefined};
          $http({
            method: 'PUT',
            url: API() + 'users/photos/' + scope.main.user.profile.userId, 
            headers: headers, 
            data: {
              files: scope.ui.newProfilePhoto
            },
            transformRequest: function (data, headersGetter) {
              var formData = new FormData();
              angular.forEach(data, function (value, key) {
                formData.append(key, value);
              });
    
              var headers = headersGetter();
              delete headers['Content-Type'];
    
              return formData;
            }
          }).then(function(res) {
    
            if (res.data && res.data.success && res.data.response) {
    
              // Set profile image
              scope.main.user.profile.photo = res.data.response;
              defer.resolve();
            } 
            else {
              defer.reject();
            }
          }, function() {
            defer.reject();
          });

          return defer.promise;
        };

        scope.onNextOnboardingClick = function() {
          if (scope.ui.onboardingIndex < scope.ui.onboardingSlides.length) {
            // Execute next function
            var fn = scope.ui.onboardingSlides[scope.ui.onboardingIndex].next;
            fn();
          }
          else {
            scope.closeOnboarding();
          }
        };

        scope.showOnboarding = function() {
          scope.ui.showOnboarding = true;
          scope.ui.onboardingUser = angular.copy(scope.main.user.profile);
          scope.ui.onboardingUserSettings = angular.copy(scope.main.user.settings);
        };

        scope.closeOnboarding = function() {
          scope.ui.showOnboarding = false;
          scope.ui.onboardingIndex = 0;
        };

        scope.getRelativeTime = function(stamp) {
          return moment(parseInt(stamp)).fromNow();
        };

        scope.viewConnection = function(connId) {
          if (!connId) {
            $state.go('settings');
          }
          else {
            $state.go('connections', {connectionId: connId});
          }
        };

        scope.clearNotification = function(notif) {

          makeNotificationUpdate(notif).then(function() {
            // Remove from notifications
            var index = _.findIndex(scope.main.user.notifications, {_id: notif});
            if (index > -1) {
              scope.main.user.notifications.splice(index, 1);
            }
          });
        };

        scope.clearAllNotifications = function() {
          _.each(scope.main.user.notifications, function(notif) {
            scope.clearNotification(notif._id);
          });
        };

        scope.settings = function() {
          scope.ui.showUserMenu = false;
          $state.go('settings');
        };

        scope.logoff = function() {
          scope.ui.showUserMenu = false;
          UserService.logout();
          $timeout(function() {
            $state.go('auth', {replace: true});
            $timeout(function() {
              $window.location.reload();
            });
          });
        };
      }
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('playerfinder')
    .directive('fileInput', ['$parse', FileInputDirective]);

  /** @ngInject */
  function FileInputDirective($parse) {
    return {
      restrict: 'A',
      link: function (scope, el, attr) {
        var model = $parse(attr.fileModel);
        var modelSetter = model.assign;
        el.bind('change', function() {
          scope.$apply(function() {
            modelSetter(scope, el[0].files[0]);
            scope.$eval(attr.fileChange);
          });
        });
      }
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('playerfinder')
    .directive('dropdown', [DropdownDirective]);

  /** @ngInject */
  function DropdownDirective() {
    return {
      restrict: 'E',
      scope: {
        model: '=',
        options: '=',
        placeholder: '@',
        displayKey: '@',
        change: '='
      },
      link: function (scope, el, attr) {
        scope.ui = {
          open: false
        };

        scope.selectOption = function(option) {
          scope.ui.open = false;
          scope.model = option;

          if (angular.isDefined(scope.change)) {
            scope.change(option);
          }
        };
      },
      template: '<div ng-class="{empty: !model}" class="dropdown"><div class="dropdown-label" ng-click="$event.stopPropagation(); ui.open=true">{{model && displayKey ? model[displayKey] : model && !displayKey ? model : placeholder}} <span class="icon-chevron-down"></span></div><div class="dropdown-options" ng-if="ui.open" click-outside outside="ui.open=false"><ul><li ng-click="$event.stopPropagation(); selectOption(option)" ng-repeat="option in options track by $index"><span ng-if="displayKey">{{option[displayKey]}}</span><span ng-if="!displayKey">{{option}}</span></li></ul></div></div>'
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('playerfinder')
    .directive('clickOutside', ['$document', '$timeout', '$parse', ClickOutsideDirective]);

  /** @ngInject */
  function ClickOutsideDirective($document, $timeout, $parse) {
    return {
      restrict: 'A',
      link: function (scope, el, attr) {
        var fn = $parse(attr.outside);

        scope.$on('$destroy', function() {
          $document.off('click', handleClick);
        });

        $timeout(function() { $document.on('click', handleClick); });

        function handleClick(e) {
          if (el !== e.target && !el[0].contains(e.target) && !angular.element(e.target).hasClass('ignore')) {
            scope.$apply(function () {
              fn(scope, {$event: e});
            });
          }
        }
      }
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('playerfinder')
    .controller('AuthController', AuthController);

  /** @ngInject */
  function AuthController($timeout, $stateParams, md5, UserService, $state, APP_DEFAULTS, $q, $http, $scope, $rootScope) {
    var vm = this;
    vm.ui = {
      forgot: false,
      verifyUser: false,
      newUser: true,
      newUserStep: 1,
      newUserError: false,
      existingUserError: false,
      appDefaults: APP_DEFAULTS,
      coppaStep: 1,
      forgotStep: 1
    };

    vm.data = {
      existingUser: {},
      newUser: {},
      coppaUser: {}
    };

    $timeout(init);

    function init() {
      vm.ui.verifyUser = false;
      vm.ui.forgot = false;
      vm.ui.reset = false;

      if ($stateParams && $stateParams.type) {
        if ($stateParams.type === 'login') {
          vm.ui.newUser = false;
        }
        else if ($stateParams.type === 'forgot') {
          vm.ui.newUser = false;
          vm.ui.forgot = true;
          vm.ui.forgotStep = 1;
        }
        else if ($stateParams.type === 'reset' && $stateParams.hash && $stateParams.token) {
          vm.ui.newUser = false;
          vm.ui.reset = true;
          vm.ui.resetStep = 1;
          vm.ui.resetError = false;
        }
        else if ($stateParams.type === 'verify') {
          vm.ui.verifyUser = true;
          vm.ui.coppaStep = 1;
          vm.data.coppaUser = false;

          // Get coppa user
          UserService.getCoppaAccount($stateParams.hash).then(function(user) {
            vm.data.coppaUser = user;
          }, function() {
            vm.data.coppaUser = false;
          });

          return;
        }
      }
    }

    vm.continueWithNewAccount = function() {
      vm.ui.newUserError = false;
      var today = moment();
      var min = moment('1/1/1900');
      var max = moment().add(-3, 'years');
      var dob = moment(vm.data.newUser.birthday);

      if (dob.isValid() && dob.isAfter(min) && dob.isBefore(max)) {
        var age = today.diff(dob, 'years');
        
        // Check if user is under 13
        vm.data.newUser.coppa = age < 13;
        vm.ui.newUserStep = 2;
      }
      else {
        vm.ui.newUserError = true;
      }
    };

    vm.createCoppaAccount = function() {
      vm.ui.newUserError = false;
      var params = {
        coppa: true,
        verified: false,
        username: vm.data.newUser.username,
        parentName: vm.data.newUser.coppaParentName,
        parentEmail: vm.data.newUser.coppaParentEmail.toLowerCase(),
        created: moment().valueOf().toString(),
        dob: moment(vm.data.newUser.birthday).valueOf(),
        hash: md5.createHash(vm.data.newUser.username + moment().valueOf().toString())
      };

      UserService.createNewCoppaAccount(params).then(function(res) {
        if (res) {
          vm.ui.newUserStep = 3;
        }
        else {
          vm.ui.newUserError = true;
        }
      }, function() {
        vm.ui.newUserError = true;
      });
    };

    vm.login = function() {
      vm.ui.existingUserError = false;

      var params = {
        email: vm.data.existingUser.email.toLowerCase(),
        password: md5.createHash(vm.data.existingUser.password)
      };

      UserService.login(params).then(function(success) {
        if (success) {
          // Continue
          $state.go('feed', {replace: true});
        }
        else {
          vm.ui.existingUserError = true;
        }
      }, function() {
        vm.ui.existingUserError = true;
      });
    };

    vm.forgotPw = function() {
      var params = {
        email: vm.ui.forgotEmail.toLowerCase()
      };

      UserService.forgot(params).then(function(success) {
        if (success) {
          // Continue
          vm.ui.forgotStep = 2;
        }
      }, function() {
        vm.ui.forgotStep = 2;
      });
    };

    vm.resetPw = function() {
      vm.ui.resetError = false;
      var params = {
        userId: $stateParams.hash,
        resetToken: $stateParams.token,
        password: md5.createHash(vm.ui.resetPw)
      };

      UserService.resetPassword(params).then(function(success) {
        vm.ui.resetStep = 2;
        if (!success) {
          vm.ui.resetError = "We were unable to reset your password. It's possible that the provided reset link expired. Please try again.";
        }
      }, function() {
        vm.ui.resetStep = 2;
        vm.ui.resetError = "We were unable to reset your password. It's possible that the provided reset link expired. Please try again.";
      });
    };

    vm.createNonCoppaAccount = function() {
      vm.ui.newUserError = false;
      $scope.main.ui.loading = true;

      var params = {
        fname: vm.data.newUser.fname,
        lname: vm.data.newUser.lname,
        gender: vm.data.newUser.gender,
        email: vm.data.newUser.email.toLowerCase(),
        password: md5.createHash(vm.data.newUser.password),
        phone: vm.data.newUser.phone,
        county: vm.data.newUser.county,
        zip: vm.data.newUser.zip,
        created: moment().valueOf().toString(),
        dob: moment(vm.data.newUser.birthday).valueOf()
      };

      // If we have a USTA level / captain, let's store it
      if (vm.data.newUser.ustaLevel || vm.data.newUser.captain) {
        params.settings = {};
        
        if (vm.data.newUser.ustaLevel) {
          params.settings.ustaLevel = vm.data.newUser.ustaLevel;
        }

        if (vm.data.newUser.captain) {
          params.settings.captain = vm.data.newUser.captain;
        }
      }

      getLocationFromZip(vm.data.newUser.zip).then(function(location) {
        params.location = {type: 'Point', coordinates: [location.lat, location.lng]};


        UserService.createNewAccount(params).then(function(res) {
          $scope.main.ui.loading = false;

          if (res.data && res.data.success) {
            // All good, set to step 3
            vm.ui.newUserStep = 3;
          }
          else {
            vm.ui.newUserError = true;
          }
        }, function() {
          $scope.main.ui.loading = false;
          vm.ui.newUserError = true;
        });
    

      }, function(err) {
        console.log('non-coppa: error obtaining location');
        vm.ui.newUserError = true;
        $scope.main.ui.loading = false;
      });
    };

    vm.continueToAccount = function() {
      $state.go('settings', {replace: true});
    };

    vm.continueToFeed= function() {
      $rootScope.$broadcast("EVENTS.START_ONBOARDING");
      $state.go('feed', {replace: true});
    };

    vm.confirmCoppaAccount = function() {
      vm.ui.newUserError = false;
      $scope.main.ui.loading = true;

      var params = {
        $set: {
          fname: vm.data.coppaUser.fname,
          lname: vm.data.coppaUser.lname,
          gender: vm.data.coppaUser.gender,
          email: vm.data.coppaUser.email.toLowerCase(),
          password: md5.createHash(vm.data.coppaUser.password),
          phone: vm.data.coppaUser.phone,
          county: vm.data.coppaUser.county,
          zip: vm.data.coppaUser.zip,
          verified: true,
          verifiedDate: moment().valueOf()
        }
      };

      getLocationFromZip(vm.data.coppaUser.zip).then(function(location) {
        params.$set.location = {type: 'Point', coordinates: [location.lat, location.lng]};

        UserService.updateCoppaAccount($stateParams.hash, {params: params}).then(function() {
          $scope.main.ui.loading = false;
          vm.ui.coppaStep = 2;
        }, function() {
          vm.ui.newUserError = true;
          $scope.main.ui.loading = false;
        });

      }, function(err) {
        console.log('coppa: error obtaining location');
        vm.ui.newUserError = true;
        $scope.main.ui.loading = false;
      });
    };

    function getLocationFromZip(zip) {
      var defer = $q.defer();
      $http({
        method: 'GET', 
        url: vm.ui.appDefaults.geocode + zip, 
        headers: {
         'Content-Type': undefined,
         'x-access-token': undefined
       },
      }).then(function(res) {
        if (res.status === 200 && res.data && res.data.results.length > 0) {
          defer.resolve(res.data.results[0].geometry.location);
        }
        else {
          defer.reject();
        }
      });

      return defer.promise;
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('playerfinder')
    .run(runBlock);

  /** @ngInject */
  function runBlock(UserService, $http, $rootScope, $location, $window) {
    if (UserService.currentUser()) {
      $http.defaults.headers.common['x-access-token'] = UserService.currentUser().token;
    }

    // redirect to login page if not logged in and trying to access a restricted page
    var locationChange = $rootScope.$on('$locationChangeStart', onLocationChange);

    $rootScope.$on("$stateChangeSuccess", function() {
      $window.scrollTo(0, 0);
    });

    $rootScope.$on('$destroy', function() {
      locationChange();
    });

    function onLocationChange() {
      var publicPages = ['/','/auth','/privacy','/about','/contact'];
      var path = $location.path();

      // Remove everything past /
      if (path.indexOf('/', 1) > -1) {
        var toIndex = path.indexOf('/', 1);
        path = path.substring(0, toIndex);
      }

      var restrictedPage = publicPages.indexOf(path) === -1;
      if (restrictedPage && !UserService.currentUser()) {
        $location.path('/auth');
      }
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('playerfinder')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('about', {
        url: '/about',
        templateUrl: 'app/info/info.html',
        controller: 'InfoController',
        controllerAs: 'vm',
        params: {
          type: 'about'
        }
      })
      .state('contact', {
        url: '/contact',
        templateUrl: 'app/info/info.html',
        controller: 'InfoController',
        controllerAs: 'vm',
        params: {
          type: 'contact'
        }
      })
      .state('privacy', {
        url: '/privacy',
        templateUrl: 'app/info/info.html',
        controller: 'InfoController',
        controllerAs: 'vm',
        params: {
          type: 'privacy'
        }
      })
      .state('feed', {
        url: '/',
        templateUrl: 'app/feed/feed.html',
        controller: 'FeedController',
        controllerAs: 'vm'
      })
      .state('settings', {
        url: '/settings/:section',
        templateUrl: 'app/settings/settings.html',
        controller: 'SettingsController',
        controllerAs: 'vm',
        params: {
          section: {
            squash: true,
            default: null
          }
        }
      })
      .state('favorites', {
        url: '/favorites',
        templateUrl: 'app/list/list.html',
        controller: 'ListController',
        controllerAs: 'vm'
      })
      .state('connections', {
        url: '/connections/:connectionId',
        templateUrl: 'app/list/list.html',
        controller: 'ListController',
        controllerAs: 'vm',
        params: {
          connectionId: {
            squash: true,
            default: null
          }
        }
      })
      .state('auth', {
        url: '/auth/:type/:hash/:token',
        templateUrl: 'app/auth/auth.html',
        controller: 'AuthController',
        controllerAs: 'vm',
        params: {
          type: {
            squash: true,
            default: null
          },
          hash: {
            squash: true,
            default: null
          },
          token: {
            squash: true,
            default: null
          }
        }
      });

    $urlRouterProvider.otherwise('/auth');
  }

})();

/* global moment:false */
(function() {
  'use strict';

  angular
    .module('playerfinder')
    .constant('moment', moment)
    .constant('API', function() {
      if (window.location.hostname.indexOf('localhost') > -1) {
        return 'http://localhost:8000/api/';
      }

      return 'https://plyrfndr.com/api/';
    })
    .constant('USER_DEFAULTS', {
      notificationMethods: {}
    })
    .constant('MARKETING', {
      privacy: {
        header: 'Privacy',
        body: 'Your privacy is of the utmost importance to us. Please review our policy below if you would like to learn more',
        link: 'https://app.termly.io/document/privacy-policy/f598c828-84b3-4384-b601-c22949f0c908',
        linkCta: 'View Policy'
      },
      about: {
        header: 'About plyrfndr',
        body: 'plyrfndr is the latest way to find nearby players to play tennis with. plyrfndr is brought to you by USTA Atlanta - A non-profit organization founded in 1980. The mission of USTA Atlanta (The Atlanta Community Tennis Association) is to promote and develop the growth of tennis in metro Atlanta.  USTA Atlanta oversees the largest USTA Leagues and USTA Jr. Team Tennis league programs in the country.'
      },
      contact: {
        header: 'Contact',
        body: 'Get in touch with the team behind plyrfndr',
        list: [
          {
            header: 'Maegan Kulich',
            subheader: 'Director of Adult Programs',
            cta: 'Email Maegan',
            ctaLink: 'mailto:maegan@ustaatlanta.com'
          },
          {
            header: 'Chris Clayton',
            subheader: 'Adult and Junior Programs Coordinator',
            cta: 'Email Chris',
            ctaLink: 'mailto:cclayton@ustaatlanta.com'
          },
          {
            header: 'Amanda Hunt',
            subheader: 'Director of Junior Programs',
            cta: 'Email Amanda',
            ctaLink: 'mailto:amanda@ustaatlanta.com'
          }
        ]
      }
    })
    .constant('APP_DEFAULTS', {
      sorts: [{key: 'fname', label: 'Name'}, {key: 'location', label: 'Distance'}],
      created: [{key: 'createdSixMonth', label: 'Created within 6 mon.'}, {key: 'createdAll', label: 'Created at any time'}],
      milesToRadian: function(miles) { return miles/3963; },
      geocode: 'https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyCr7MnwD46FPqQ5Az6xXR9kYDdWSsEYJQA&address=',
      ustaProfile: {
        junior: 'https://tennislink.usta.com/TeamTennis/Main/Stats.aspx?Load=AdvSearch&Search=MemberID&ID=',
        adult: 'https://tennislink.usta.com/leagues/Main/StatsAndStandings.aspx?t=R-17&search='
      },
      distance: ['Less than 1 mile away', 'Less than 5 miles away', 'Less than 10 miles away', 'Less than 20 miles away'],
      counties: ['Douglas', 'East Cobb', 'West Cobb', 'Forsyth', 'South Fulton', 'North Fulton', 'Gwinnett', 'ITP', 'South DeKalb', 'North DeKalb', 'Paulding', 'Smyrna'],
      genders: ['Male', 'Female'],
      leagues: {
        adult: ['18 & Over Men','18 & Over Weekday Women','18 & Over Business Women','Mixed 18 & Over','Tri-Level 18 & Over','40 & Over Men','40 & Over Weekday Women','40 & Over Business Women','Mixed 40 & Over','Tri-Level 40 & Over','55 & Over Men (Wednesday)','55 & Over Men (Saturday)','55 & Over Women','65 & Over Men','65 & Over Women'],
        junior: ['8 & Under', '10 & Under', '12 & Under', '14 & Under', '18 & Under'],
        all: ['8 & Under', '10 & Under', '12 & Under', '14 & Under', '18 & Under', '18 & Over Men','18 & Over Weekday Women','18 & Over Business Women','Mixed 18 & Over','Tri-Level 18 & Over','40 & Over Men','40 & Over Weekday Women','40 & Over Business Women','Mixed 40 & Over','Tri-Level 40 & Over','55 & Over Men (Wednesday)','55 & Over Men (Saturday)','55 & Over Women','65 & Over Men','65 & Over Women']
      },
      ageGroups: {
        junior: [
          {label: '8 & Under', amount: 9, date: 'March 7', low: 1, high: 9}, 
          {label: '10 & Under', amount: 11, date: 'September 1', low: 10, high: 11},
          {label: '12 & Under', amount: 13, date: 'September 1', low: 12, high: 13},
          {label: '14 & Under', amount: 15, date: 'September 1', low: 14, high: 15},
          {label: '18 & Under', amount: 19, date: 'September 1', low: 18, high: 20}
        ],
        adult: [
          {label: '18 & Over', amount: 18, low: 18, high: 39}, 
          {label: '40 & Over', amount: 40, low: 40, high: 54},
          {label: '55 & Over', amount: 55, low: 55, high: 64},
          {label: '65 & Over', amount: 65, low: 65, high: 200}
        ]
      },
      availableYears: [2019, 2020, 2021],
      availableSeasons: ['Winter', 'Spring', 'Summer', 'Fall'],
      altaLevels: {
        junior: ['Beginner','Intermediate','Advanced'],
        adult: ['2.5','3.0','3.5','4.0','4.5','5.0','5.5'],
        all: ['Beginner','Intermediate','Advanced', '2.5','3.0','3.5','4.0','4.5','5.0','5.5']
      },
      matchTypes: ['Singles Only', 'Doubles Only', 'Prefer Singles', 'Prefer Doubles', 'Singles or Doubles'],
      matchSides: ['Deuce Only', 'Prefer Deuce', 'Ad Only', 'Prefer Ad', 'Either Side'],
      teamTypes: {
        adult: ['Men', 'Women', 'Mixed'],
        junior: ['Junior Boys', 'Junior Girls', 'Junior Coed'],
        all: ['Men', 'Women', 'Mixed', 'Junior Boys', 'Junior Girls', 'Junior Coed'],
      }
    });

})();

(function() {
  'use strict';

  angular
    .module('playerfinder')
    .config(config);

  /** @ngInject */
  function config($locationProvider, $provide, $httpProvider) {
    // Enable html 5
    $locationProvider.html5Mode(true);

    // Make sure our token is valid
    $provide.factory('unauthorisedInterceptor', ['$q', '$localStorage', function ($q, $localStorage) {
      return {
        'responseError': function(rejection) {
          if (rejection.status === 403) {
            delete $localStorage.playerFinderCurrentUser;
            window.location.href = '/auth/login';
          }

          return $q.reject(rejection);
        }
      };
    }]);
 
    $httpProvider.interceptors.push('unauthorisedInterceptor');
  }

})();

angular.module("playerfinder").run(["$templateCache", function($templateCache) {$templateCache.put("app/auth/auth.html","<!-- Verify --><div class=auth-container ng-if=vm.ui.verifyUser><div ng-if=\"vm.ui.coppaStep == 1 && vm.data.coppaUser && !vm.data.coppaUser.verified\"><h1>Hi {{vm.data.coppaUser.parentName}}, let\'s finish setting up your child\'s account</h1><form name=coppaForm><h3><span class=required>*</span> Email</h3><input name=email type=email ng-model=vm.data.coppaUser.email placeholder=\"Email address...\"><div class=error ng-if=\"coppaForm.$submitted && !coppaForm.email.$valid\">Please enter a valid email address</div><h3><span class=required>*</span> Password</h3><input type=password name=password ng-model=vm.data.coppaUser.password placeholder=Password... minlength=6><div class=error ng-if=\"coppaForm.password.$dirty && !coppaForm.password.$valid\">Please enter a password (at least 6 characters)</div><h4>Contact Info</h4><h3><span class=required>*</span> First Name</h3><input type=text name=fname ng-model=vm.data.coppaUser.fname placeholder=\"First Name...\" minlength=2><div class=error ng-if=\"coppaForm.$submitted && !coppaForm.fname.$valid\">Please enter a first name</div><h3><span class=required>*</span> Last Name</h3><input type=text name=lname ng-model=vm.data.coppaUser.lname placeholder=\"Last Name...\" minlength=2><div class=error ng-if=\"coppaForm.$submitted && !coppaForm.lname.$valid\">Please enter a first name</div><h3><span class=required>*</span> Gender</h3><dropdown model=vm.data.coppaUser.gender placeholder=\"Select a gender\" options=vm.ui.appDefaults.genders></dropdown><h3><span class=required>*</span> Phone Number</h3><phone-directive name=phone model=vm.data.coppaUser.phone is-valid=vm.ui.validPhone></phone-directive><div class=error ng-if=\"coppaForm.phone.$dirty && !vm.ui.validPhone\">Please enter a valid 10 digit phone number</div><h3><span class=required>*</span> County</h3><dropdown model=vm.data.coppaUser.county placeholder=\"Select a county\" options=vm.ui.appDefaults.counties></dropdown><h3><span class=required>*</span> Zip Code</h3><input type=text ng-model=vm.data.coppaUser.zip placeholder=\"5 digit zip code...\" ng-minlength=5 ng-maxlength=5 ng-pattern=/^[0-9]*$/ ><div class=error ng-if=\"coppaForm.zip.$dirty && !coppaForm.zip.$valid\">Please enter a valid 5 digit zip code</div></form><button class=green-btn ng-disabled=\"!vm.data.coppaUser.password || !vm.data.coppaUser.fname || !vm.data.coppaUser.lname || !vm.data.coppaUser.email || !vm.data.coppaUser.zip || !vm.data.coppaUser.county || !vm.data.coppaUser.gender\" ng-click=vm.confirmCoppaAccount()>Create</button><h5 ng-if=vm.ui.newUserError class=error>Sorry, that email address is already in use, please try again.</h5></div><div ng-if=\"vm.data.coppaUser.verified || vm.ui.coppaStep == 2\"><h1>Your child\'s account has been completed successfully!</h1><h3>Thanks for your help! Please pass along their credentials so that they can start using plyrfndr</h3><a href=auth/login class=less-btn>Log In now</a></div></div><!-- New User --><div class=auth-container ng-if=\"!vm.ui.verifyUser && vm.ui.newUser\"><div class=big-user-icon><span class=icon-user></span></div><h1>Join PlyrFndr</h1><div ng-if=\"vm.ui.newUserStep == 1\"><a href=auth/login class=less-btn>Already have an account?</a><h3><span class=required>*</span> Please enter your birthday</h3><input type=date placeholder=\"My birthday...\" ng-model=vm.data.newUser.birthday> <button class=green-btn ng-disabled=!vm.data.newUser.birthday ng-click=vm.continueWithNewAccount()>Continue</button><h5 ng-if=vm.ui.newUserError class=red>Please enter a valid birthday</h5></div><div ng-if=\"vm.ui.newUserStep == 2 && vm.data.newUser.coppa\"><h3 class=red>Based on your age, we need to get a parent\'s consent</h3><h3><span class=required>*</span> Please enter a username a parent would recognize</h3><input type=text ng-model=vm.data.newUser.username placeholder=Username...><h3><span class=required>*</span> Please enter a parent\'s name</h3><input type=text ng-model=vm.data.newUser.coppaParentName placeholder=\"A parent\'s name...\"><h3><span class=required>*</span> Please enter a parent\'s email address</h3><input type=email ng-model=vm.data.newUser.coppaParentEmail placeholder=\"A parent\'s email address...\"><div class=btn-container><button class=back-btn ng-click=\"vm.ui.newUserStep = 1\">Back</button> <button class=green-btn ng-disabled=\"!vm.data.newUser.username || !vm.data.newUser.coppaParentName || !vm.data.newUser.coppaParentEmail\" ng-click=vm.createCoppaAccount()>Continue</button></div><h5 ng-if=vm.ui.newUserError class=red>Sorry, there was an error creating your account, please try again.</h5></div><div ng-if=\"vm.ui.newUserStep == 3 && vm.data.newUser.coppa\"><h3>Your account has been submitted for approval!</h3><h4>Once your parent approves your account, you will be able to start using plyrfndr.</h4><h4>We hope to see you on plyrfndr soon!</h4><div class=btn-container><button class=green-btn ng-click=\"vm.ui.newUserStep = 1\">Done</button></div><h5 ng-if=vm.ui.newUserError class=red>Sorry, there was an error creating your account, please try again.</h5></div><div ng-if=\"vm.ui.newUserStep == 2 && !vm.data.newUser.coppa\"><h3>Great, let\'s gather some information</h3><h4>Log In</h4><form name=newUserForm><h3><span class=required>*</span> Email</h3><input type=email name=email ng-model=vm.data.newUser.email placeholder=\"Email address...\"><div class=error ng-if=\"newUserForm.email.$dirty && !newUserForm.email.$valid\">Please enter a valid email address</div><h3><span class=required>*</span> Password</h3><input type=password name=password ng-model=vm.data.newUser.password placeholder=Password... minlength=6><div class=error ng-if=\"newUserForm.password.$dirty && !newUserForm.password.$valid\">Please enter a password (at least 6 characters)</div><h4>Contact Info</h4><h3><span class=required>*</span> First Name</h3><input type=text name=fname ng-model=vm.data.newUser.fname placeholder=\"First Name...\" minlength=2><div class=error ng-if=\"newUserForm.fname.$dirty && !newUserForm.fname.$valid\">Please enter a first name greater than two characters</div><h3><span class=required>*</span> Last Name</h3><input type=text name=lname ng-model=vm.data.newUser.lname placeholder=\"Last Name...\" minlength=2><div class=error ng-if=\"newUserForm.lname.$dirty && !newUserForm.lname.$valid\">Please enter a last name greater than two characters</div><h3><span class=required>*</span> Gender</h3><dropdown model=vm.data.newUser.gender placeholder=\"Select a gender\" options=vm.ui.appDefaults.genders></dropdown><h3><span class=required>*</span> Phone Number</h3><phone-directive name=phone model=vm.data.newUser.phone is-valid=vm.ui.validPhone></phone-directive><div class=error ng-if=\"newUserForm.phone.$dirty && !vm.ui.validPhone\">Please enter a valid 10 digit phone number</div><h3><span class=required>*</span> County</h3><dropdown model=vm.data.newUser.county placeholder=\"Select a county\" options=vm.ui.appDefaults.counties></dropdown><h3><span class=required>*</span> Zip Code</h3><input type=text name=zip ng-model=vm.data.newUser.zip placeholder=\"5 digit zip code...\" ng-minlength=5 ng-maxlength=5 ng-pattern=/^[0-9]*$/ ><div class=error ng-if=\"newUserForm.zip.$dirty && !newUserForm.zip.$valid\">Please enter a valid 5 digit zip code</div><h3><span class=required>*</span> USTA Level</h3><dropdown model=vm.data.newUser.ustaLevel options=vm.ui.appDefaults.altaLevels.all placeholder=\"Select your Playing Level...\"></dropdown><div class=error ng-if=\"newUserForm.zip.$dirty && !vm.data.newUser.ustaLevel\">Please select a playing level</div><h3><span class=required>*</span> Willing to captain?</h3><dropdown model=vm.data.newUser.captain options=\"[\'Yes\',\'No\']\" placeholder=\"Select yes or no...\"></dropdown><div class=error ng-if=\"newUserForm.zip.$dirty && !vm.data.newUser.captain\">Please select yes or no</div></form><div class=btn-container><button class=back-btn ng-click=\"vm.ui.newUserStep = 1\">Back</button> <button class=green-btn ng-disabled=\"!vm.data.newUser.captain || !vm.data.newUser.ustaLevel || !vm.data.newUser.password || !vm.data.newUser.fname || !vm.data.newUser.lname || !vm.data.newUser.email || !vm.data.newUser.phone || !vm.data.newUser.zip || !vm.data.newUser.county || !vm.data.newUser.gender\" ng-click=vm.createNonCoppaAccount()>Create</button></div><h5 ng-if=vm.ui.newUserError class=error>Sorry, that email already exists. Please try again or <a href=auth/login>login here</a>.</h5></div><div ng-if=\"vm.ui.newUserStep == 3 && !vm.data.newUser.coppa\"><h1>All set!</h1><h4>It\'s time to make some connections on plyrfndr!</h4><!-- <p>Continue onto your account now to configure your discovery, notification, and team settings!</p>\n    <div class=\"btn-container\">\n      <button class=\"green-btn\" ng-click=\"vm.continueToAccount()\">Continue to my account</button>\n    </div> --><p>Let\'s take you to your feed - where you will find players/teams in the area. But first, we\'ll help you complete your profile and set up your preferences.</p><div class=btn-container><button class=green-btn ng-click=vm.continueToFeed()>Sounds good</button></div></div></div><!-- Existing User --><div class=auth-container ng-if=\"!vm.ui.verifyUser && !vm.ui.newUser && !vm.ui.forgot && !vm.ui.reset\"><h1>Welcome back</h1><a href=auth class=less-btn>Need to create an account?</a><form name=loginForm><h3>Email</h3><input name=email type=email ng-model=vm.data.existingUser.email placeholder=\"Email address...\"><div class=error ng-if=\"loginForm.$submitted && !loginForm.email.$valid\">Please enter a valid email address</div><h3>Password</h3><input name=password type=password ng-model=vm.data.existingUser.password placeholder=Password...><div class=error ng-if=\"loginForm.$submitted && !loginForm.password.$valid\">Please enter your password</div></form><button class=green-btn ng-click=vm.login() ng-disabled=\"!vm.data.existingUser.password || !vm.data.existingUser.email || vm.data.existingUser.password.length < 5\">Log In</button><h5 ng-if=vm.ui.existingUserError class=error>Sorry, your email and/or password were incorrect. Please try again</h5><a href=auth/forgot class=blue-text-btn>Forgot your Password?</a></div><!-- Forgot PW --><div class=auth-container ng-if=\"!vm.ui.verifyUser && !vm.ui.newUser && vm.ui.forgot\"><h1>Reset your password</h1><p>Don’t worry, we all forget. We’ll email you instructions on how to reset your password.</p><div ng-if=\"vm.ui.forgotStep == 1\"><form name=forgotForm><h3>Email</h3><input name=email type=email ng-model=vm.ui.forgotEmail placeholder=\"Email address...\"><div class=error ng-if=\"forgotForm.$submitted && !forgotForm.email.$valid\">Please enter a valid email address</div></form><button class=green-btn ng-click=vm.forgotPw() ng-disabled=!vm.ui.forgotEmail>Send Email</button> <a href=auth/login class=blue-text-btn>Cancel</a></div><div ng-if=\"vm.ui.forgotStep == 2\"><h2>Awesome, thanks</h2><p>If an account exists with the email that you provided, you should receive instructions shortly.</p><a href=auth/login class=blue-text-btn>Done</a></div></div><!-- Reset PW --><div class=auth-container ng-if=\"!vm.ui.verifyUser && !vm.ui.newUser && !vm.ui.forgot && vm.ui.reset\"><h1>Create a new password</h1><div ng-if=\"vm.ui.resetStep == 1\"><form name=resetForm><h3>New Password (at least 6 characters)</h3><input name=password type=password ng-model=vm.ui.resetPw placeholder=\"New password...\" minlength=6><div class=error ng-if=\"resetForm.$submitted && !resetForm.password.$valid\">Please enter a valid password</div><input name=passwordConfirm type=password ng-model=vm.ui.resetPwConfirm placeholder=\"Confirm New password...\" minlength=6><div class=error ng-if=\"!resetForm.password.$valid || vm.ui.resetPw != vm.ui.resetPwConfirm\">Your passwords do not match</div></form><button class=green-btn ng-click=vm.resetPw() ng-disabled=\"!vm.ui.resetPw || !vm.ui.resetPwConfirm || vm.ui.resetPw != vm.ui.resetPwConfirm\">Reset</button> <a href=auth/login class=blue-text-btn>Cancel</a></div><div ng-if=\"vm.ui.resetStep == 2 && vm.ui.resetError\"><h2>Oops, there was an issue</h2><p>{{vm.ui.resetError}}</p><a href=auth/forgot class=blue-text-btn>Try again</a></div><div ng-if=\"vm.ui.resetStep == 2 && !vm.ui.resetError\"><h2>All set!</h2><p>Your password has been reset successfully! Feel free to login with your new password now.</p><a href=auth/login class=blue-text-btn>Login</a></div></div>");
$templateCache.put("app/components/header.template.html","<header class=header ng-class=\"{admin: main.user.profile.isAdmin}\"><!-- Onboarding --><div class=onboarding-overlay ng-if=ui.showOnboarding><div class=onboarding-overlay-content><button class=close-btn ng-click=closeOnboarding()><span class=icon-x></span></button><div class=onboarding-flex><div class=onboarding-top><div class=onboarding-header><h3>{{ui.onboardingIndex+1}} of {{ui.onboardingSlides.length}}</h3><h1>{{ui.onboardingSlides[ui.onboardingIndex].title.replace(\"{name}\", main.user.profile.fname)}}</h1></div><p>{{ui.onboardingSlides[ui.onboardingIndex].body}}</p><img src=assets/images/logo.png ng-if=ui.onboardingSlides[ui.onboardingIndex].showLogo class=logo alt=\"plyrfndr logo\"></div><div ng-if=ui.onboardingSlides[ui.onboardingIndex].profileForm class=onboarding-form><!-- Profile --><h3>Photo</h3><img class=existing-photo ng-if=main.user.profile.photo ng-src=\"{{ui.api + main.user.profile.photo}}\" alt=\"my profile photo\"> <input class=upload-file type=file id=profile-photo file-input file-model=ui.newProfilePhoto accept=image/*><label class=upload-label for=profile-photo>{{ui.newProfilePhoto ? ui.newProfilePhoto.name : \'Select\'}}</label><h3>First Name</h3><input type=text ng-model=ui.onboardingUser.fname><h3>Last Name</h3><input type=text ng-model=ui.onboardingUser.lname><h3>About me</h3><textarea type=text ng-model=ui.onboardingUser.about placeholder=\"About me...\" maxlength=250></textarea></div><div ng-if=ui.onboardingSlides[ui.onboardingIndex].playForm class=onboarding-form><!-- play --><h3>USTA #</h3><input type=text ng-model=ui.onboardingUserSettings.ustaNumber placeholder=\"Enter your USTA #...\"><h3>USTA Level</h3><dropdown model=ui.onboardingUserSettings.ustaLevel options=\"main.user.isJunior ? ui.appDefaults.altaLevels.junior : ui.appDefaults.altaLevels.all\" placeholder=\"Select your Playing Level...\"></dropdown><h3>ALTA Level</h3><input type=text ng-model=ui.onboardingUserSettings.altaLevel placeholder=\"Enter your ALTA Level...\"><h3>Preferred Match Type</h3><dropdown model=ui.onboardingUserSettings.matchType options=ui.appDefaults.matchTypes placeholder=\"Select your Preferred Match Type...\"></dropdown><h3>Preferred Side</h3><dropdown model=ui.onboardingUserSettings.matchSide options=ui.appDefaults.matchSides placeholder=\"Select your Preferred Side...\"></dropdown><h3>Are you willing to captain?</h3><dropdown model=ui.onboardingUserSettings.captain options=\"[\'Yes\',\'No\']\" placeholder=\"Select yes or no...\"></dropdown><h3>Allow me to be discovered by teams looking for players during the season:</h3><dropdown model=ui.onboardingUser.discoverable options=\"[\'No\', \'Winter\', \'Spring\', \'Summer\', \'Fall\']\" placeholder=Select...></dropdown><h3>Allow me to be discovered by players looking for players to hit with</h3><div class=toggle-switch ng-class=\"{selected: ui.onboardingUser.hitWith}\" ng-click=\"ui.onboardingUser.hitWith = !ui.onboardingUser.hitWith\"></div></div><div ng-if=ui.onboardingSlides[ui.onboardingIndex].notifForm class=onboarding-form><h3>Methods</h3><ul class=multi-picker><li class=\"selected disabled\">App: You\'ll always receive notifications within this application</li><li ng-class=\"{selected: ui.onboardingUserSettings.notificationMethods.email}\" ng-click=\"toggleNotifs(\'email\')\">Email: We\'ll also dispatch notifications to your email address</li><li ng-class=\"{selected: ui.onboardingUserSettings.notificationMethods.phone}\" ng-click=\"toggleNotifs(\'phone\')\">Phone: We\'ll also dispatch notifications via text to your phone number</li></ul></div><div class=onboarding-btns><div ng-if=ui.onboardingError class=error>{{ui.onboardingError}}</div><button class=next-btn ng-click=onNextOnboardingClick()>{{ui.onboardingSlides[ui.onboardingIndex].nextButton}}</button> <button class=skip-btn ng-if=ui.onboardingSlides[ui.onboardingIndex].allowSkip ng-click=onOnboardingSkipClick()>Skip</button></div></div></div></div><!-- End Onboarding --><!-- Mobile Menu --><div class=mobile-menu ng-if=ui.showMobileMenu><button class=close-btn ng-click=\"ui.showMobileMenu=false\"><span class=icon-x></span></button><ul ng-if=!main.user.profile><li ng-click=\"ui.showMobileMenu=false\"><a href=auth/login>Log In</a></li><li ng-click=\"ui.showMobileMenu=false\"><a href=auth>Join</a></li></ul><ul ng-if=main.user.profile><li ng-click=\"ui.showMobileMenu=false\"><a href=/ >Home</a></li><!-- <li ng-if=\"!main.user.isJunior\" ng-click=\"ui.showMobileMenu=false; showOnboarding()\"><span class=\"icon-book-open\"></span> Help</li> --><li ng-click=\"ui.showMobileMenu=false; settings()\">My Account</li><li ng-click=\"ui.showMobileMenu=false; ui.showFavorites=true\"><a href=/favorites><span class=icon-heart></span> Favorites <span ng-if=\"main.user.settings.favorites.player.length > 0 || main.user.settings.favorites.team.length > 0\" class=unread-mail>{{main.user.settings.favorites.player.length + main.user.settings.favorites.team.length}}</span></a></li><li ng-click=\"ui.showMobileMenu=false\"><a href=/connections><span class=icon-message-circle></span> Connections <span ng-if=\"main.user.connections.length > 0\" class=unread-mail>{{main.user.connections.length}}</span></a></li><li ng-click=\"ui.showMobileMenu=false; ui.showMobileNotifs=true\"><span class=icon-bell></span> Notifications <span ng-if=\"main.user.notifications.length > 0\" class=unread-mail>{{main.user.notifications.length}}</span></li><li ng-click=\"ui.showMobileMenu=false; logoff()\">Log Off</li></ul></div><!-- Mobile Menu --><!-- Mobile Notifs --><div class=mobile-menu ng-if=ui.showMobileNotifs><button class=close-btn ng-click=\"ui.showMobileNotifs=false\"><span class=icon-x></span></button><div class=mobile-notifications><h3>Notifications</h3><button class=clear-all-btn ng-if=\"main.user.notifications.length > 0\" ng-click=clearAllNotifications()>Clear all</button><ul ng-if=\"main.user.notifications.length > 0\"><li ng-repeat=\"notif in main.user.notifications track by notif._id\"><button class=view-btn ng-click=viewConnection(notif.action)>{{notif.body}}</button><h6>{{getRelativeTime(notif.created)}}</h6><button class=clear-btn ng-click=clearNotification(notif._id)>Clear</button></li></ul><h5 ng-if=\"main.user.notifications.length < 1\">You don\'t have any notifications.</h5></div></div><!-- Mobile Notifs --> <button class=\"mobile-only menu-btn\" ng-click=\"ui.showMobileMenu=true\"><span class=icon-menu></span></button><div class=logo-left><a href=/ ><img src=assets/images/usta-dark.png alt=\"usta logo\" ng-if=!main.user.profile.isAdmin><h2 ng-if=!main.user.profile.isAdmin>Atlanta</h2><h2 ng-if=main.user.profile.isAdmin>ADMIN</h2></a></div><a href=/ ><img src=assets/images/logo.png class=logo alt=\"plyrfndr logo\"></a><ul class=\"user-nav desktop-only\" ng-if=!main.user.profile><li><a href=auth/login>Log In</a></li><li><a class=blue-btn href=auth>Join</a></li></ul><ul class=user-nav ng-if=main.user.profile><li class=desktop-only ng-if=!main.user.profile.isAdmin><a href=/ >Home</a></li><li ng-if=\"!main.user.isJunior && !main.user.profile.isAdmin\" class=desktop-only ng-click=showOnboarding()><span class=icon-book-open></span> Help</li><li class=desktop-only ng-if=!main.user.profile.isAdmin ng-click=\"ui.showFavorites=true\"><a href=/favorites><span class=icon-heart></span><span ng-if=\"main.user.settings.favorites.player.length > 0 || main.user.settings.favorites.team.length > 0\" class=unread-mail>{{main.user.settings.favorites.player.length + main.user.settings.favorites.team.length}}</span> </a></li><li class=desktop-only ng-if=!main.user.profile.isAdmin><a href=/connections><span class=icon-message-circle></span><span ng-if=\"main.user.connections.length > 0\" class=unread-mail>{{main.user.connections.length}}</span></a></li><li class=desktop-only ng-if=!main.user.profile.isAdmin ng-click=\"ui.showNotifs=true\"><span class=icon-bell></span><span ng-if=\"main.user.notifications.length > 0\" class=unread-mail>{{main.user.notifications.length}}</span><div class=mail-popup ng-if=ui.showNotifs click-outside outside=\"ui.showNotifs=false\"><h3>Notifications</h3><button class=clear-all-btn ng-if=\"main.user.notifications.length > 0\" ng-click=clearAllNotifications()>Clear all</button><ul ng-if=\"main.user.notifications.length > 0\"><li ng-repeat=\"notif in main.user.notifications track by notif._id\"><button class=view-btn ng-click=viewConnection(notif.action)>{{notif.body}}</button><h6>{{getRelativeTime(notif.created)}}</h6><button class=clear-btn ng-click=clearNotification(notif._id)>Clear</button></li></ul><h5 ng-if=\"main.user.notifications.length < 1\">You don\'t have any notifications.</h5></div></li><li ng-click=\"ui.showUserMenu=true\"><div class=user-icon style=\"{{main.user.profile.photo ? \'background-image:url(\' + ui.api + main.user.profile.photo + \')\' : \'\'}}\"><span ng-if=!main.user.profile.photo>{{main.user.profile.fname[0]}}{{main.user.profile.lname[0]}}</span></div><div class=\"mail-popup desktop-only\" ng-if=\"ui.showUserMenu && !main.user.profile.isAdmin\" click-outside outside=\"ui.showUserMenu=false\"><h3>My Account</h3><ul><li ng-click=\"$event.stopPropagation(); settings()\">Manage</li><li ng-click=\"$event.stopPropagation(); logoff()\">Log Off</li></ul></div><div class=\"mail-popup desktop-only\" ng-if=\"ui.showUserMenu && main.user.profile.isAdmin\" click-outside outside=\"ui.showUserMenu=false\"><h3>Admin</h3><ul><li ng-click=\"$event.stopPropagation(); logoff()\">Log Off</li></ul></div></li></ul></header>");
$templateCache.put("app/feed/feed.html","<!-- Admin --><div class=feed-container ng-if=main.user.profile.isAdmin><!-- Type picker --><ul class=\"multi-picker inline dark\"><li ng-class=\"{selected: vm.ui.adminMode==\'players\'}\" ng-click=\"vm.setAdminMode(\'players\')\">Players</li><li ng-class=\"{selected: vm.ui.adminMode==\'teams\'}\" ng-click=\"vm.setAdminMode(\'teams\')\">Teams</li><li class=export filename=admin_export.csv csv-header=vm.getCSVHeader() ng-csv=vm.getCSV()>Export <i ng-if=vm.playersSelected()>selected</i> <span class=icon-paperclip></span></li></ul><div class=\"feed-searchbar dark\"><h3 class=feed-count>{{vm.ui.adminNumResults}} {{vm.ui.adminMode == \"players\" ? vm.ui.adminNumResults == 1 ? \"player\" : \"players\" : vm.ui.adminNumResults == 1 ? \"team\" : \"teams\"}}</h3><input type=text ng-model=vm.ui.search placeholder=\"Search {{vm.ui.adminMode}}...\"> <button class=filter-btn ng-class=\"{active: vm.ui.adminFilterCount >  0}\" ng-if=\"vm.ui.adminMode==\'players\'\" ng-click=\"vm.ui.showAdminFilters=true\"><span class=icon-sliders></span> Filter <span class=filter-count>{{vm.ui.adminFilterCount}}</span></button> <button class=\"filter-btn active\" ng-if=vm.connectPlayersEnabled() ng-click=vm.showMatch()><span class=icon-check></span> Connect Selected</button><!-- Admin Filters --><div class=admin-filters ng-if=vm.ui.showAdminFilters><h3>Filter Players</h3><div class=filter-body><div class=filter-box ng-repeat=\"(key, filter) in vm.ui.adminFilters track by $index\"><div class=filter-header><h4 ng-click=\"filter.collapsed = !filter.collapsed\">{{filter.label}} <span ng-if=\"filter.selected != \'Any\'\">{{filter.selected.length}}</span></h4><button class=toggle-btn ng-click=\"filter.collapsed = !filter.collapsed\">{{filter.collapsed ? \'+\' : \'-\'}}</button></div><ul ng-if=!filter.collapsed><li ng-class=\"{selected: filter.selected == \'Any\'}\" ng-click=\"vm.toggleAdminFilter(filter, \'Any\', key)\">Any</li><li ng-repeat=\"option in filter.available track by $index\" ng-click=\"vm.toggleAdminFilter(filter, option, key)\" ng-class=\"{selected: filter.selected.indexOf(option) > -1}\">{{option}}</li></ul></div></div><div class=filter-buttons><button class=cancel-btn ng-click=vm.cancelAdminFilters()>Clear Filters</button> <button class=save-btn ng-click=vm.saveAdminFilters()>Save</button></div></div><!-- End Admin Filters --><div class=feed-sort><h4 ng-click=\"vm.ui.showSortDirection=true\">Direction: {{vm.ui.direction.label}}</h4><div class=feed-sort-popup ng-if=vm.ui.showSortDirection click-outside outside=\"vm.ui.showSortDirection=false\"><h5>Direction</h5><ul><li ng-click=\"vm.setAdminSortDirection({label: \'Ascending\', key: \'asc\'})\">Ascending</li><li ng-click=\"vm.setAdminSortDirection({label: \'Descending\', key: \'desc\'})\">Descending</li></ul></div></div><div class=feed-sort style=\"margin-right: 20px\"><h4 ng-click=\"vm.ui.showSort=true\">Sort By: {{vm.ui.sort.label}}</h4><div class=feed-sort-popup ng-if=vm.ui.showSort click-outside outside=\"vm.ui.showSort=false\"><h5>Sort By</h5><ul><li ng-if=\"vm.ui.adminMode==\'players\'\" ng-click=\"vm.setAdminSort({label: \'Name\', key: \'fname\'})\">Name</li><li ng-if=\"vm.ui.adminMode==\'teams\'\" ng-click=\"vm.setAdminSort({label: \'Name\', key: \'name\'})\">Name</li><li ng-if=\"vm.ui.adminMode==\'players\'\" ng-click=\"vm.setAdminSort({label: \'Age\', key: \'dob\'})\">Age</li><li ng-if=\"vm.ui.adminMode==\'players\'\" ng-click=\"vm.setAdminSort({label: \'Level\', key: \'settings.ustaLevel\'})\">Level</li><li ng-click=\"vm.setAdminSort({label: \'County\', key: \'county\'})\">County</li><li ng-if=\"vm.ui.adminMode==\'teams\'\" ng-click=\"vm.setAdminSort({label: \'League\', key: \'league\'})\">League</li><li ng-if=\"vm.ui.adminMode==\'teams\'\" ng-click=\"vm.setAdminSort({label: \'Created\', key: \'created\'})\">Created</li><li ng-if=\"vm.ui.adminMode==\'teams\'\" ng-click=\"vm.setAdminSort({label: \'Season\', key: \'season\'})\">Season</li><li ng-if=\"vm.ui.adminMode==\'players\'\" ng-click=\"vm.setAdminSort({label: \'Created\', key: \'created\'})\">Created</li></ul></div></div><div class=feed-sort style=\"margin-right: 20px\"><h4 ng-click=\"vm.ui.showCreatedFilter=true\">Show Items: {{vm.ui.created.label}}</h4><div class=feed-sort-popup ng-if=vm.ui.showCreatedFilter click-outside outside=\"vm.ui.showCreatedFilter=false\"><h5>Show Items:</h5><ul><li ng-click=\"vm.setAdminCreated({label: \'Created within 6 mon.\', key: \'createdSixMonth\'})\">Created within 6 mon.</li><li ng-click=\"vm.setAdminCreated({label: \'Created at any time\', key: \'createdAll\'})\">Created at any time</li></ul></div></div></div><!-- Players --><ul class=admin-list ng-if=\"vm.ui.adminMode==\'players\'\"><li><div class=select>Select</div><div>Name</div><div class=small>Age</div><div class=small>Gender</div><div class=small>Level</div><div class=small>Willing to Captain</div><div>County</div><div>Email</div><div>Phone</div><div class=small>Created</div></li><li ng-repeat=\"player in vm.getAdminPlayers() | limitTo:2000 track by player._id\" ng-if=player.fname ng-click=vm.adminEditPlayer(player)><div class=select><button ng-click=\"vm.selectPlayer($event, player)\" class=select-btn ng-class=\"{selected: vm.adminData.selectedPlayers[player._id]}\"><span class=icon-check></span></button></div><div>{{player.fname}} {{player.lname}}</div><div class=small>{{player.age}}</div><div class=small>{{player.gender}}</div><div class=small ng-class=\"{gray: !player.settings || !player.settings.ustaLevel}\">{{player.settings && player.settings.ustaLevel ? player.settings.ustaLevel : \"n/a\"}}</div><div class=small>{{player.settings && player.settings.captain ? player.settings.captain : \"No\"}}</div><div>{{player.county}}</div><div>{{player.email}}</div><div>{{player.phone | phoneNumberFilter}}</div><div class=small>{{player.created | date:\'longDate\'}}</div></li></ul><!-- Teams --><ul class=admin-list ng-if=\"vm.ui.adminMode==\'teams\'\"><li><div>Name</div><div>Facility</div><div class=small>County</div><div>League</div><div class=small>Type</div><div class=small>Level</div><div class=small>Season</div><div class=small>Created</div></li><li ng-repeat=\"team in vm.getAdminTeams() | limitTo:1000 track by team._id\" ng-if=team.name ng-click=vm.adminEditTeam(team)><div>{{team.name}}</div><div>{{team.facility}}</div><div class=small>{{team.county}}</div><div>{{team.league}}</div><div class=small>{{team.type}}</div><div class=small>{{team.level}}</div><div class=small>{{team.season}}</div><div class=small>{{team.created | date:\'longDate\'}}</div></li></ul><!-- Pagination --><div class=pagination><ul><li ng-click=vm.setAdminPage(page.page) ng-class=\"{disabled: vm.ui.pagination.page == page.page}\" ng-repeat=\"page in vm.ui.pagination.pages track by $index\">{{page.label}}</li></ul></div><!-- Admin Match Players --><div class=selected-player ng-if=vm.ui.showAdminMatch><div class=selected-player-content><button class=close-btn ng-click=\"vm.ui.showAdminMatch = false\"><span class=icon-x></span></button><h2>Connect Players</h2><ul class=player-details style=\"margin: 40px 0 0\" ng-if=\"!vm.ui.adminConnectResult && !vm.ui.adminConnectResultError\"><li ng-repeat=\"(key,val) in vm.adminData.selectedPlayers track by key\"><h3>{{val.fname}} {{val.lname}}</h3><h3>{{val.email}}</h3><h3>{{val.phone | phoneNumberFilter}}</h3></li></ul><div ng-if=\"!vm.ui.adminConnectResultError && vm.ui.adminConnectResult\"><h3>The connection has been generated successfully!</h3></div><div class=update-player-area><div class=error ng-if=vm.ui.adminConnectResultError>Sorry, there was an error connecting these players. Please try again.</div><button class=green-btn ng-if=\"vm.ui.adminConnectResultError || !vm.ui.adminConnectResult\" ng-click=vm.createConnectionFromAdmin()>Connect</button><p><button class=back-btn ng-click=\"vm.ui.showAdminMatch=false\">Close</button></p></div></div></div><!-- Admin Match Players --><!-- Admin View Player --><div class=selected-player ng-if=vm.ui.adminViewPlayer><div class=selected-player-content><button class=admin-delete-btn ng-click=vm.deletePlayer()>Delete</button> <button class=close-btn ng-click=\"vm.ui.adminViewPlayer = false\"><span class=icon-x></span></button><ul class=player-details style=\"margin: 40px 0 0\"><li><h3>First Name</h3><input type=text ng-model=vm.ui.adminViewPlayer.fname placeholder=\"First name...\"></li><li><h3>Last Name</h3><input type=text ng-model=vm.ui.adminViewPlayer.lname placeholder=\"Last name...\"></li><li><h3>Birthday</h3><input type=date ng-model=vm.ui.adminViewPlayer.birthday placeholder=Birthday...></li><li><h3>Email</h3><input type=email ng-model=vm.ui.adminViewPlayer.email placeholder=Email...></li><li><h3>Phone</h3><phone-directive name=phone model=vm.ui.adminViewPlayer.phone is-valid=vm.ui.validPhone></phone-directive></li><li><h3>About</h3><input type=text ng-model=vm.ui.adminViewPlayer.about placeholder=About...></li><li><h3>Zip Code</h3><input type=text ng-model=vm.ui.adminViewPlayer.zip placeholder=\"Zip Code...\"></li><li><h3>County</h3><dropdown model=vm.ui.adminViewPlayer.county options=vm.ui.appDefaults.counties placeholder=\"Select a county...\"></dropdown></li><li><h3>USTA Number</h3><input type=text ng-model=vm.ui.adminViewPlayer.settings.userNumber placeholder=\"USTA #...\"></li><li><h3>USTA Level</h3><dropdown model=vm.ui.adminViewPlayer.settings.ustaLevel options=\"vm.ui.adminViewPlayer.age < 18  ? vm.ui.appDefaults.altaLevels.junior : vm.ui.appDefaults.altaLevels.all\" placeholder=\"Playing Level...\"></dropdown></li><li><h3>ALTA Level</h3><input type=text ng-model=vm.ui.adminViewPlayer.settings.altaLevel placeholder=\"ALTA Level...\"></li><li><h3>Willing to captain</h3><dropdown model=vm.ui.adminViewPlayer.settings.captain options=\"[\'Yes\',\'No\']\" placeholder=n/a></dropdown></li><li><h3>Preferred Match Type</h3><dropdown model=vm.ui.adminViewPlayer.settings.matchType options=vm.ui.appDefaults.matchTypes placeholder=n/a></dropdown></li><li><h3>Preferred Side</h3><dropdown model=vm.ui.adminViewPlayer.settings.matchSide options=vm.ui.appDefaults.matchSides placeholder=n/a></dropdown></li></ul><div class=update-player-area><div class=error ng-if=vm.ui.adminError>Sorry, there was an error updating this player. Please try again.</div><button class=green-btn ng-click=vm.makePlayerUpdates()>Update player</button><p><button class=back-btn ng-click=\"vm.ui.adminViewPlayer=false\">Close</button></p></div></div></div><!-- Admin View Player --><!-- Admin View Team --><div class=selected-player ng-if=vm.ui.adminViewTeam><div class=selected-player-content><button class=admin-delete-btn ng-click=vm.deleteTeam()>Delete</button> <button class=close-btn ng-click=\"vm.ui.adminViewTeam = false\"><span class=icon-x></span></button><ul class=player-details style=\"margin: 40px 0 0\"><li><h3>Name</h3><input type=text ng-model=vm.ui.adminViewTeam.name placeholder=\"Team name...\"></li><li><h3>About</h3><input type=text ng-model=vm.ui.adminViewTeam.about placeholder=\"About the team...\"></li><li><h3>Facility</h3><input type=text ng-model=vm.ui.adminViewTeam.facility placeholder=\"Facility name...\"></li><li><h3>County</h3><dropdown model=vm.ui.adminViewTeam.county options=vm.ui.appDefaults.counties placeholder=\"Select a County...\"></dropdown></li><li><h3>League</h3><dropdown model=vm.ui.adminViewTeam.league options=vm.ui.appDefaults.leagues.all placeholder=\"Select League...\"></dropdown></li><li><h3>Type</h3><dropdown model=vm.ui.adminViewTeam.type options=vm.ui.appDefaults.teamTypes.all placeholder=\"Select Team Type...\"></dropdown></li><li><h3>Playing Level</h3><dropdown model=vm.ui.adminViewTeam.level options=vm.ui.appDefaults.altaLevels.all placeholder=\"Select Playing Level...\"></dropdown></li><li><h3>Season</h3><dropdown model=vm.ui.adminViewTeam.season options=vm.ui.appDefaults.availableSeasons placeholder=\"Select your Season...\"></dropdown></li></ul><div class=update-player-area><div class=error ng-if=vm.ui.adminError>Sorry, there was an error updating this team. Please try again.</div><button class=green-btn ng-click=vm.makeTeamUpdates()>Update team</button><p><button class=back-btn ng-click=\"vm.ui.adminViewTeam=false\">Close</button></p></div></div></div><!-- Admin View Team --></div><div class=feed-container ng-if=!main.user.profile.isAdmin><!-- Selected Player --><div class=selected-player ng-if=vm.ui.selectedPlayer ng-init=\"vm.ui.connect=vm.ui.connectTeam=vm.ui.connectResult=false;vm.ui.playerTab=\'profile\'\"><div class=selected-player-content click-outside outside=\"vm.ui.selectedPlayer = false\"><button class=close-btn ng-click=\"vm.ui.selectedPlayer = false\"><span class=icon-x></span></button><div class=action-bar><button ng-if=\"(main.user.connections | filter:{type:(vm.ui.type == \'hit\' ? \'hit\' : \'team\'), to: vm.ui.selectedPlayer._id}).length<1 && (main.user.connections | filter:{type:(vm.ui.type == \'hit\' ? \'hit\' : \'team\'), from: vm.ui.selectedPlayer._id}).length<1\" ng-click=\"vm.ui.connect=true; vm.ui.connectMessage=\'\'\" ng-disabled=vm.ui.connect><span class=icon-message-circle></span> Connect</button> <button ng-if=\"(main.user.connections | filter:{type:(vm.ui.type == \'hit\' ? \'hit\' : \'team\'), to: vm.ui.selectedPlayer._id}).length>0 || (main.user.connections | filter:{type:(vm.ui.type == \'hit\' ? \'hit\' : \'team\'), from: vm.ui.selectedPlayer._id}).length>0\" ng-click=vm.viewConnection(vm.ui.selectedPlayer._id) class=selected><span class=icon-message-circle></span> View Connection</button> <button ng-class=\"{selected: main.user.settings.favorites.player.indexOf(vm.ui.selectedPlayer._id) > -1}\" ng-click=\"vm.toggleFavorite(\'player\', vm.ui.selectedPlayer)\"><span class=icon-heart></span> {{main.user.settings.favorites.player.indexOf(vm.ui.selectedPlayer._id) > -1 ? \'Remove from favorites\' : \'Add to Favorites\'}}</button></div><div class=content-container ng-if=vm.ui.connect><div ng-if=!vm.ui.connectResult><h2>Connect with <strong>{{vm.ui.selectedPlayer.fname}}</strong></h2><h3 ng-if=\"vm.ui.type == \'players\' && main.user.teams.length > 0\">Include a team you\'ve created</h3><dropdown ng-if=\"vm.ui.type == \'players\' && main.user.teams.length > 0\" model=vm.ui.connectTeam options=main.user.teams placeholder=\"Select a Team...\" display-key=name></dropdown><h3>Include a message</h3><textarea ng-model=vm.ui.connectMessage></textarea><div class=button-group><button class=cancel-btn ng-click=\"$event.stopPropagation(); vm.ui.connect=false\">Cancel</button> <button class=save-btn ng-click=vm.createConnection()>Connect</button></div></div><div ng-if=vm.ui.connectResult><h2>{{vm.ui.connectResultError ? \'Sorry, there was an issue connecting, please try again.\' : \"All set! We\'ll let you know when you receive a response from \" + vm.ui.selectedPlayer.fname}}</h2><div class=button-group><button class=cancel-btn ng-if=vm.ui.connectResultError ng-click=\"$event.stopPropagation(); vm.ui.connect=vm.ui.connectResult=false\">Cancel</button> <button class=save-btn ng-click=\"$event.stopPropagation(); vm.ui.connectResult=false\" ng-if=vm.ui.connectResultError>Try again</button> <button class=save-btn ng-click=\"vm.ui.selectedPlayer=false\">Done</button></div></div></div><div class=content-container ng-if=!vm.ui.connect><div class=flex-container><div class=\"flex-left floated\"><div class=\"big-user-icon float\" style=\"{{!main.user.isJunior && vm.ui.selectedPlayer.photo ? \'background-image:url(\' + vm.ui.api + vm.ui.selectedPlayer.photo + \')\' : \'\'}}\"><span ng-if=!vm.ui.selectedPlayer.photo>{{vm.ui.selectedPlayer.fname[0]}}</span></div><div class=\"info-bucket float\"><h3>{{vm.ui.selectedPlayer.fname}}</h3><p class=highlighted>{{vm.ui.selectedPlayer.about ? vm.ui.selectedPlayer.about : \'No about me just yet...\'}}</p><p>{{vm.ui.selectedPlayer.age}} years old</p><p><i>Profile last updated <strong ng-if=!vm.ui.selectedPlayer.lastUpdated>{{vm.ui.selectedPlayer.created | date:\'longDate\'}}</strong> <strong ng-if=vm.ui.selectedPlayer.lastUpdated>{{vm.ui.selectedPlayer.lastUpdated | date:\'longDate\'}}</strong></i></p></div></div></div></div><ul class=tabbar ng-if=\"!vm.ui.connect && vm.ui.selectedPlayer.teamProfiles\"><li ng-class=\"{selected: vm.ui.playerTab==\'profile\'}\" ng-click=\"vm.ui.playerTab=\'profile\'\">{{vm.ui.selectedPlayer.fname}}\'s Profile</li><li ng-class=\"{selected: vm.ui.playerTab==\'teamProfiles\'}\" ng-click=\"vm.ui.playerTab=\'teamProfiles\'\">Teams {{vm.ui.selectedPlayer.fname}} is looking for</li></ul><ul class=data-list ng-if=\"!vm.ui.connect && vm.ui.playerTab==\'teamProfiles\'\"><li><div>Type/League/Level</div><div>County/Zip</div><div>What I\'m Looking For</div></li><li ng-repeat=\"profile in vm.ui.selectedPlayer.teamProfiles track by profile.profileId\"><div>{{profile.type}} / {{profile.league}} / {{profile.level}}</div><div>{{profile.county}} / {{profile.zip}}</div><div>{{profile.about ? profile.about : \'n/a\'}}</div></li></ul><ul class=player-details ng-if=\"!vm.ui.connect && vm.ui.playerTab==\'profile\'\"><li><h3>Zip Code</h3><h4>{{vm.ui.selectedPlayer.zip}}</h4></li><li><h3>County</h3><h4>{{vm.ui.selectedPlayer.county}}</h4></li><li ng-if=vm.ui.selectedPlayer.settings.ustaNumber><h3>USTA History</h3><h4><a target=_blank href=\"{{(main.user.isJunior ? vm.ui.appDefaults.ustaProfile.junior : vm.ui.appDefaults.ustaProfile.adult)}}{{vm.ui.selectedPlayer.settings.ustaNumber}}\">View</a></h4></li><li ng-if=vm.ui.selectedPlayer.settings.ustaLevel><h3>USTA Level</h3><h4>{{vm.ui.selectedPlayer.settings.ustaLevel}}</h4></li><li ng-if=vm.ui.selectedPlayer.settings.altaLevel><h3>ALTA Level</h3><h4>{{vm.ui.selectedPlayer.settings.altaLevel}}</h4></li><li ng-if=vm.ui.selectedPlayer.settings.matchType><h3>Preferred Match Type</h3><h4>{{vm.ui.selectedPlayer.settings.matchType}}</h4></li><li ng-if=vm.ui.selectedPlayer.settings.matchSide><h3>Preferred Side</h3><h4>{{vm.ui.selectedPlayer.settings.matchSide}}</h4></li><li><h3>Willing to captain</h3><h4>{{vm.ui.selectedPlayer.settings.captain ? vm.ui.selectedPlayer.settings.captain : \'n/a\'}}</h4></li></ul></div></div><!-- Selected Team --><div class=selected-player ng-if=vm.ui.selectedTeam ng-init=\"vm.ui.connect=vm.ui.connectResult=false\"><div class=\"selected-player-content team\" click-outside outside=\"vm.ui.selectedTeam = false\"><button class=close-btn ng-click=\"vm.ui.selectedTeam = false\"><span class=icon-x></span></button><div class=action-bar ng-if=\"vm.ui.selectedTeam.createdBy != main.user.profile.userId\"><button ng-if=\"(main.user.connections | filter:{type:\'team\', to: vm.ui.selectedTeam.createdBy}).length<1 && (main.user.connections | filter:{type:\'team\', from: vm.ui.selectedTeam.createdBy}).length<1\" ng-click=\"vm.ui.connect=true; vm.ui.connectMessage=\'\'\" ng-disabled=vm.ui.connect><span class=icon-message-circle></span> Connect</button> <button ng-if=\"(main.user.connections | filter:{type:\'team\', to: vm.ui.selectedTeam.createdBy}).length>0 || (main.user.connections | filter:{type:\'team\', from: vm.ui.selectedTeam.createdBy}).length>0\" ng-click=vm.viewConnection(vm.ui.selectedTeam.createdBy) class=selected><span class=icon-message-circle></span> View Connection</button> <button ng-class=\"{selected: main.user.settings.favorites.team.indexOf(vm.ui.selectedTeam._id) > -1}\" ng-click=\"vm.toggleFavorite(\'team\', vm.ui.selectedTeam)\"><span class=icon-heart></span> {{main.user.settings.favorites.team.indexOf(vm.ui.selectedTeam._id) > -1 ? \'Remove from favorites\' : \'Add to Favorites\'}}</button></div><div class=action-bar ng-if=\"vm.ui.selectedTeam.createdBy == main.user.profile.userId\"><button ng-click=vm.viewSettings()><span class=icon-settings></span> Manage in settings</button></div><div class=content-container ng-if=vm.ui.connect><div ng-if=!vm.ui.connectResult><h2>Connect with <strong>{{vm.ui.selectedTeam.name}}</strong></h2><h3>Include a message</h3><textarea ng-model=vm.ui.connectMessage></textarea><div class=button-group><button class=cancel-btn ng-click=\"$event.stopPropagation(); vm.ui.connect=false\">Cancel</button> <button class=save-btn ng-click=vm.createConnection()>Connect</button></div></div><div ng-if=vm.ui.connectResult><h2>{{vm.ui.connectResultError ? \'Sorry, there was an issue connecting, please try again.\' : \"All set! We\'ll let you know when you receive a response from the manager of \" + vm.ui.selectedTeam.name}}</h2><div class=button-group><button class=cancel-btn ng-if=vm.ui.connectResultError ng-click=\"$event.stopPropagation(); vm.ui.connect=vm.ui.connectResult=false\">Cancel</button> <button class=save-btn ng-click=\"$event.stopPropagation(); vm.ui.connectResult=false\" ng-if=vm.ui.connectResultError>Try again</button> <button class=save-btn ng-click=\"vm.ui.selectedTeam=false\">Done</button></div></div></div><div class=content-container ng-if=!vm.ui.connect><div class=info-bucket><h3>{{vm.ui.selectedTeam.name}}</h3><p class=highlighted>\"{{vm.ui.selectedTeam.about ? vm.ui.selectedTeam.about : \'No about just yet...\'}}\"</p><p>Team created <strong>{{vm.ui.selectedTeam.created | date:\'longDate\'}}</strong></p></div></div><ul class=player-details ng-if=!vm.ui.connect><li><h3>Facility / ZIP</h3><h4>{{vm.ui.selectedTeam.facility}} / {{vm.ui.selectedTeam.facilityZip}}</h4></li><li><h3>Type</h3><h4>{{vm.ui.selectedTeam.type}}</h4></li><li><h3>County</h3><h4>{{vm.ui.selectedTeam.county}}</h4></li><li><h3>League</h3><h4>{{vm.ui.selectedTeam.league}}</h4></li><li><h3>Season</h3><h4>{{vm.ui.selectedTeam.season}}</h4></li><li><h3>Level</h3><h4>{{vm.ui.selectedTeam.level}}</h4></li></ul></div></div><!-- Normal --><div class=flex-container><button class=\"filter-toggle mobile-only\" ng-click=\"vm.ui.hideFilters=!vm.ui.hideFilters\"><span class=icon-sliders></span> {{vm.ui.hideFilters ? \'Show\' : \'Hide\'}} Filters <span class=filter-count ng-if=\"vm.ui.filterCount > 0\">({{vm.ui.filterCount}})</span></button><div class=\"flex-left one\" ng-if=!vm.ui.hideFilters><div class=big-dropdown><h1 ng-click=\"vm.ui.showTypes=true\">{{vm.ui.type == \'hit\' ? \'Someone to hit with\' : vm.ui.type == \'players\' ? \'Players looking for teams\' : \'Teams looking for players\'}}</h1><ul ng-if=vm.ui.showTypes click-outside outside=\"vm.ui.showTypes=false\"><li ng-click=\"vm.setType(\'hit\')\">Someone to hit with</li><li ng-click=\"vm.setType(\'players\')\">Players looking for teams</li><li ng-click=\"vm.setType(\'teams\')\">Teams looking for players</li></ul></div><button ng-click=vm.createNewTeam() class=new-team-btn ng-if=\"vm.ui.type == \'players\'\"><span class=icon-plus></span> Create a new find a team request</button> <button ng-click=vm.createNewTeam() class=new-team-btn ng-if=\"vm.ui.type == \'teams\'\"><span class=icon-plus></span> Create a new team</button><h3 ng-if=!main.user.isJunior>Age Preference</h3><div class=junior-adult-toggle ng-if=!main.user.isJunior><div ng-class=\"{selected: main.user.settings.agePreference==\'junior\'}\" ng-click=\"vm.setAgePreference(\'junior\')\">Junior</div><div ng-class=\"{selected: main.user.settings.agePreference==\'adult\'}\" ng-click=\"vm.setAgePreference(\'adult\')\">Adult</div></div><div class=filter-top-header><h3><span class=filter-count ng-if=\"vm.ui.filterCount > 0\">{{vm.ui.filterCount}}</span> Filter by:</h3><button class=clear-all-btn ng-if=\"vm.ui.filterCount > 0\" ng-click=vm.clearAllFilters()>Clear all</button></div><div class=filter-box ng-repeat=\"(key, filter) in vm.ui.filters track by $index\" ng-if=filter.show[vm.ui.type]><div class=filter-header><h4 ng-click=\"filter.collapsed = !filter.collapsed\">{{filter.label}} <span ng-if=\"filter.selected != \'Any\'\">{{filter.selected.length}}</span></h4><button class=toggle-btn ng-click=\"filter.collapsed = !filter.collapsed\">{{filter.collapsed ? \'+\' : \'-\'}}</button></div><ul ng-if=!filter.collapsed><li ng-class=\"{selected: filter.selected == \'Any\'}\" ng-click=\"vm.toggleFilter(filter, \'Any\', key)\">Any</li><li ng-repeat=\"option in filter.available track by $index\" ng-click=\"vm.toggleFilter(filter, option, key)\" ng-class=\"{selected: filter.selected.indexOf(option) > -1}\">{{option}}</li></ul></div></div><div class=\"flex-right three left\"><div class=feed-searchbar><input type=text ng-model=vm.ui.search placeholder=\"Search results...\"><div class=feed-sort><h4 ng-click=\"vm.ui.showSort=true\">Sort By: {{vm.ui.sort.label}}</h4><div class=feed-sort-popup ng-if=vm.ui.showSort click-outside outside=\"vm.ui.showSort=false\"><h5>Sort By</h5><ul><li ng-repeat=\"sort in vm.ui.appDefaults.sorts track by sort.key\" ng-click=vm.setSort(sort)>{{sort.label}}</li></ul></div></div></div><h5 ng-if=\"vm.ui.type != \'teams\' && vm.data.players[vm.ui.type].length < 1\">No players match your search...</h5><h5 ng-if=\"vm.ui.type == \'teams\' && vm.data.teams.length < 1\">No teams match your search...</h5><!-- Teams --><ul class=\"player-cards teams\" ng-class=\"{list: vm.ui.view == \'list\'}\" ng-if=\"vm.ui.type == \'teams\'\"><li ng-repeat=\"team in vm.data.teams | filter:vm.ui.search track by team._id\" ng-click=\"vm.ui.selectedTeam = team\"><div class=player-full-div><h4 class=team-name>{{team.name}}</h4>{{team.facility ? team.facility : \'&nbsp;\'}}</div><div class=player-split-div><div class=split-div>{{team.county}}</div><div class=split-div>{{team.level}}</div></div><div class=player-full-div>{{team.league}}</div><div class=\"player-full-div clip\">{{team.about ? (team.about | limitTo:50) + (team.about.length > 50 ? \'...\' : \'\') : \'No about just yet...\'}}</div></li></ul><!-- Players --><ul class=player-cards ng-class=\"{list: vm.ui.view == \'list\'}\" ng-if=\"vm.ui.type != \'teams\'\"><li ng-repeat=\"player in vm.data.players[vm.ui.type] | filter:vm.ui.search track by player._id\" ng-click=\"vm.ui.selectedPlayer = player\"><div class=player-split-div><div class=split-div><div class=user-icon style=\"{{!main.user.isJunior && player.photo ? \'background-image:url(\' + vm.ui.api + player.photo + \')\' : \'\'}}\"><span ng-if=\"main.user.isJunior || !player.photo\">{{player.fname[0]}}</span></div></div><div class=split-div><h4>{{player.fname}}</h4></div></div><div class=player-split-div><div class=split-div>{{player.age}} years old</div><div class=split-div>{{player.county}}</div></div><div class=player-split-div><div class=split-div>{{player.settings.ustaLevel ? player.settings.ustaLevel : \'No USTA level yet\'}}</div><div class=split-div>{{player.zip}}</div></div><div class=\"player-full-div clip\">{{player.about ? (player.about | limitTo:50) + (player.about.length > 50 ? \'...\' : \'\') : \'No about me yet\'}}</div></li></ul></div></div></div>");
$templateCache.put("app/info/info.html","<div class=container><h1>{{vm.ui.copy.header}}</h1><p>{{vm.ui.copy.body}}</p><a ng-if=vm.ui.copy.link href={{vm.ui.copy.link}}>{{vm.ui.copy.linkCta}}</a><ul ng-if=vm.ui.copy.list class=info-list><li ng-repeat=\"item in vm.ui.copy.list\"><h2>{{item.header}}</h2><h3>{{item.subheader}}</h3><p>{{item.body}}</p><a ng-if=item.cta href={{item.ctaLink}}>{{item.cta}}</a></li></ul></div>");
$templateCache.put("app/list/list.html","<!-- Connection Overlay --><div class=overlay ng-if=vm.ui.selectedConnection><div class=overlay-content><button class=close-btn ng-click=vm.closeConnection()><span class=icon-x></span></button><!-- Player --><h2>Connection {{vm.ui.selectedConnection.from==main.user.profile.userId ? \'to\' : \'from\'}} <strong>{{vm.ui.selectedConnection.fullPlayer.fname}}</strong> <span ng-if=\"vm.ui.selectedConnection.type == \'team\' && vm.ui.selectedConnection.fullTeam\">for {{vm.ui.selectedConnection.from == main.user.profile.userId && vm.ui.selectedConnection.fromTeam ? \'my\' : \'the\'}} team, <strong>{{vm.ui.selectedConnection.fullTeam.name}}</strong></span></h2><h3>Type: {{vm.ui.selectedConnection.type == \'hit\' ? \'Someone to hit with\' : \'Team Play\'}}</h3><h2 ng-if=\"vm.ui.selectedConnection.status != \'Accepted\'\">By accepting this connection, both players will be able to see eachother\'s contact information.</h2><div class=approve-btns ng-if=\"vm.ui.selectedConnection.from!=main.user.profile.userId && vm.ui.selectedConnection.status==\'Pending Approval\'\"><button class=reject-btn ng-click=vm.rejectConnection()>Reject</button> <button class=approve-btn ng-click=vm.approveConnection()>Accept</button><div class=error style=\"clear:both; margin:10px 0\" ng-if=vm.ui.updateError>Sorry, there was an error performing that action, please try again.</div></div><div class=status-bar><h3>Status</h3><h4><span class=\"status-icon {{vm.ui.selectedConnection.status}}\"></span> {{vm.ui.selectedConnection.status}} - {{(vm.ui.selectedConnection.updated ? vm.ui.selectedConnection.updated : vm.ui.selectedConnection.created) | date:\'MMM d, yyyy h:mm a\'}}</h4></div><div class=\"content-container acceptance\" ng-if=\"vm.ui.selectedConnection.status == \'Accepted\'\"><h4>You and {{vm.ui.selectedConnection.fullPlayer.fname}} are connected!</h4><h3>{{vm.ui.selectedConnection.from==main.user.profile.userId ? \'Here are their contact details:\' : \'Your preferred contact method has been shared \' + (main.user.settings.preferredContact ? \'(\' + main.user.settings.preferredContact + \')\' : \'(Email)\')}}</h3><div ng-if=\"vm.ui.selectedConnection.from==main.user.profile.userId\"><h3>{{vm.ui.selectedConnection.fullPlayer.settings.preferredContact ? vm.ui.selectedConnection.fullPlayer.settings.preferredContact : \'Email\'}}: <strong ng-if=\"vm.ui.selectedConnection.fullPlayer.settings.preferredContact==\'Phone\'\">{{vm.ui.selectedConnection.fullPlayer.phone | phoneNumberFilter}}</strong> <a ng-if=\"!vm.ui.selectedConnection.fullPlayer.settings.preferredContact || vm.ui.selectedConnection.fullPlayer.settings.preferredContact==\'Email\'\" href=mailto:{{vm.ui.selectedConnection.fullPlayer.email}}>{{vm.ui.selectedConnection.fullPlayer.email}}</a></h3></div><div ng-if=\"vm.ui.selectedConnection.from!=main.user.profile.userId\"><h3>Here is their preferred contact method ({{vm.ui.selectedConnection.fullPlayer.settings.preferredContact ? vm.ui.selectedConnection.fullPlayer.settings.preferredContact : \'Email\'}}): <strong ng-if=\"vm.ui.selectedConnection.fullPlayer.settings.preferredContact==\'Phone\'\">{{vm.ui.selectedConnection.fullPlayer.phone | phoneNumberFilter}}</strong> <a ng-if=\"!vm.ui.selectedConnection.fullPlayer.settings.preferredContact || vm.ui.selectedConnection.fullPlayer.settings.preferredContact==\'Email\'\" href=mailto:{{vm.ui.selectedConnection.fullPlayer.email}}>{{vm.ui.selectedConnection.fullPlayer.email}}</a></h3></div></div><div class=content-container ng-if=vm.ui.selectedConnection.message><h3>Message</h3><p>\"{{vm.ui.selectedConnection.message}}\"</p></div><div class=content-container ng-if=\"vm.ui.selectedConnection.team && vm.ui.selectedConnection.fullTeam\"><h3>Team: <strong>{{vm.ui.selectedConnection.fullTeam.name}}</strong></h3><ul class=player-details><li><h3>Facility</h3><h4>{{vm.ui.selectedConnection.fullTeam.facility}}</h4></li><li><h3>County</h3><h4>{{vm.ui.selectedConnection.fullTeam.county}}</h4></li><li><h3>League</h3><h4>{{vm.ui.selectedConnection.fullTeam.league}}</h4></li><li><h3>Season</h3><h4>{{vm.ui.selectedConnection.fullTeam.season}}</h4></li><li><h3>Level</h3><h4>{{vm.ui.selectedConnection.fullTeam.level}}</h4></li><li><h3>About</h3><h4>{{vm.ui.selectedConnection.fullTeam.about}}</h4></li></ul></div><div class=content-container><div class=flex-container><div class=\"flex-left floated\"><div class=\"big-user-icon float\" style=\"{{!main.user.isJunior && vm.ui.selectedConnection.fullPlayer.photo ? \'background-image:url(\' + vm.ui.api + vm.ui.selectedConnection.fullPlayer.photo + \')\' : \'\'}}\"><span ng-if=!vm.ui.selectedConnection.fullPlayer.photo>{{vm.ui.selectedConnection.fullPlayer.fname[0]}}</span></div><div class=\"info-bucket float\"><h3><span ng-if=\"vm.ui.selectedConnection.to != main.user.profile.userId && vm.ui.selectedConnection.team\">Team managed by</span> <strong>{{vm.ui.selectedConnection.fullPlayer.fname}}</strong></h3><p class=highlighted>\"{{vm.ui.selectedConnection.fullPlayer.about ? vm.ui.selectedConnection.fullPlayer.about : \'No about me just yet...\'}}\"</p><p>{{vm.ui.selectedConnection.fullPlayer.age}} years old</p><p><i>Profile last updated <strong ng-if=!vm.ui.selectedConnection.fullPlayer.lastUpdated>{{vm.ui.selectedConnection.fullPlayer.created | date:\'longDate\'}}</strong><strong ng-if=vm.ui.selectedConnection.fullPlayer.lastUpdated>{{vm.ui.selectedConnection.fullPlayer.lastUpdated | date:\'longDate\'}}</strong></i></p></div></div></div></div><div class=content-container ng-if=\"!vm.ui.selectedConnection.team || vm.ui.selectedConnection.to != main.user.profile.userId\"><ul class=player-details><li><h3>Zip Code</h3><h4>{{vm.ui.selectedConnection.fullPlayer.zip}}</h4></li><li><h3>County</h3><h4>{{vm.ui.selectedConnection.fullPlayer.county}}</h4></li><li ng-if=vm.ui.selectedConnection.fullPlayer.settings.ustaNumber><h3>USTA History</h3><h4><a target=_blank href=\"{{(main.user.isJunior ? vm.ui.appDefaults.ustaProfile.junior : vm.ui.appDefaults.ustaProfile.adult)}}{{vm.ui.selectedConnection.fullPlayer.settings.ustaNumber}}\">View</a></h4></li><li ng-if=vm.ui.selectedConnection.fullPlayer.settings.altaLevel><h3>ALTA Level</h3><h4>{{vm.ui.selectedConnection.fullPlayer.settings.altaLevel}}</h4></li><li ng-if=vm.ui.selectedConnection.fullPlayer.settings.matchType><h3>Preferred Match Type</h3><h4>{{vm.ui.selectedConnection.fullPlayer.settings.matchType}}</h4></li><li ng-if=vm.ui.selectedConnection.fullPlayer.settings.matchSide><h3>Preferred Side</h3><h4>{{vm.ui.selectedConnection.fullPlayer.settings.matchSide}}</h4></li><li><h3>Willing to captain</h3><h4>{{vm.ui.selectedConnection.fullPlayer.settings.captain ? vm.ui.selectedConnection.fullPlayer.settings.captain : \'n/a\'}}</h4></li></ul></div></div></div><!-- Selected Player Overlay --><div class=overlay ng-if=vm.ui.selectedPlayer><div class=overlay-content><button class=close-btn ng-click=\"vm.ui.selectedPlayer=false\"><span class=icon-x></span></button><!-- Player --><h2>{{vm.ui.selectedPlayer.fname}}</h2><p><button class=delete-btn ng-click=\"vm.removeFavorite(\'player\', vm.ui.selectedPlayer._id); vm.ui.selectedPlayer=false\"><span class=icon-trash></span> Remove from favorites</button></p><div class=content-container><div class=flex-container><div class=\"flex-left floated\"><div class=\"big-user-icon float\" style=\"{{!main.user.isJunior && vm.ui.selectedPlayer.photo ? \'background-image:url(\' + vm.ui.api + vm.ui.selectedPlayer.photo + \')\' : \'\'}}\"><span ng-if=!vm.ui.selectedPlayer.photo>{{vm.ui.selectedPlayer.fname[0]}}</span></div><div class=\"info-bucket float\"><h3>{{vm.ui.selectedPlayer.fname}}</h3><p class=highlighted>{{vm.ui.selectedPlayer.about ? vm.ui.selectedPlayer.about : \'No about me just yet...\'}}</p><p>{{vm.ui.selectedPlayer.age}} years old</p><p><i>Profile last updated <strong ng-if=!vm.ui.selectedPlayer.lastUpdated>{{vm.ui.selectedPlayer.created | date:\'longDate\'}}</strong><strong ng-if=vm.ui.selectedPlayer.lastUpdated>{{vm.ui.selectedPlayer.lastUpdated | date:\'longDate\'}}</strong></i></p></div></div></div></div><ul class=player-details><li><h3>Zip Code</h3><h4>{{vm.ui.selectedPlayer.zip}}</h4></li><li><h3>County</h3><h4>{{vm.ui.selectedPlayer.county}}</h4></li><li ng-if=vm.ui.selectedPlayer.settings.ustaNumber><h3>USTA History</h3><h4><a target=_blank href=\"{{(main.user.isJunior ? vm.ui.appDefaults.ustaProfile.junior : vm.ui.appDefaults.ustaProfile.adult)}}{{vm.ui.selectedPlayer.settings.ustaNumber}}\">View</a></h4></li><li ng-if=vm.ui.selectedPlayer.settings.altaLevel><h3>ALTA Level</h3><h4>{{vm.ui.selectedPlayer.settings.altaLevel}}</h4></li><li ng-if=vm.ui.selectedPlayer.settings.matchType><h3>Preferred Match Type</h3><h4>{{vm.ui.selectedPlayer.settings.matchType}}</h4></li><li ng-if=vm.ui.selectedPlayer.settings.matchSide><h3>Preferred Side</h3><h4>{{vm.ui.selectedPlayer.settings.matchSide}}</h4></li><li><h3>Willing to captain</h3><h4>{{vm.ui.selectedPlayer.settings.captain ? vm.ui.selectedPlayer.settings.captain : \'n/a\'}}</h4></li></ul></div></div><!-- Selected Team Overlay --><div class=overlay ng-if=vm.ui.selectedTeam><div class=overlay-content><button class=close-btn ng-click=\"vm.ui.selectedTeam=false\"><span class=icon-x></span></button><!-- Team --><h2>{{vm.ui.selectedTeam.name}}</h2><p><button class=delete-btn ng-click=\"vm.removeFavorite(\'team\', vm.ui.selectedTeam._id); vm.ui.selectedTeam=false\"><span class=icon-trash></span> Remove from favorites</button></p><div class=content-container><div class=info-bucket><p class=highlighted>\"{{vm.ui.selectedTeam.about ? vm.ui.selectedTeam.about : \'No about just yet...\'}}\"</p><p>Created <strong>{{vm.ui.selectedTeam.created | date:\'longDate\'}}</strong></p></div></div><ul class=player-details><li><h3>Facility</h3><h4>{{vm.ui.selectedTeam.facility}}</h4></li><li><h3>County</h3><h4>{{vm.ui.selectedTeam.county}}</h4></li><li><h3>League</h3><h4>{{vm.ui.selectedTeam.league}}</h4></li><li><h3>Season</h3><h4>{{vm.ui.selectedTeam.season}}</h4></li><li><h3>Age Group</h3><h4>{{vm.ui.selectedTeam.age}}</h4></li><li><h3>Level</h3><h4>{{vm.ui.selectedTeam.level}}</h4></li></ul></div></div><!-- Normal --><div class=settings-container ng-if=\"vm.ui.page==\'favorites\'\"><h2>My Favorites</h2><ul class=tabbar><li ng-class=\"{selected: vm.ui.type==\'player\'}\" ng-click=\"vm.ui.type=\'player\'\">Players</li><li ng-class=\"{selected: vm.ui.type==\'team\'}\" ng-click=\"vm.ui.type=\'team\'\">Teams</li></ul><!-- Players --><ul class=data-list ng-if=\"vm.ui.type == \'player\' && vm.data.player.length > 0\"><li><div>Player</div><div class=small></div></li><li ng-repeat=\"player in vm.data.player track by player._id\" class=actionable ng-click=\"vm.ui.selectedPlayer = player\"><div><div class=user-icon style=\"{{!main.user.isJunior && player.photo ? \'background-image:url(\'+ vm.ui.api + player.photo +\')\' : \'\'}}\"><span ng-if=\"main.user.isJunior || !player.photo\">{{player.fname[0]}}</span></div>{{player.fname}}</div><div class=small><button class=remove-btn ng-click=\"$event.stopPropagation(); vm.removeFavorite(\'player\', player._id)\"><span class=icon-trash></span> Remove</button></div></li></ul><!-- Teams --><ul class=data-list ng-if=\"vm.ui.type == \'team\' && vm.data.team.length > 0\"><li><div>Team</div><div class=small></div></li><li ng-repeat=\"team in vm.data.team | orderBy:team.created:true track by team._id\" class=actionable ng-click=\"vm.ui.selectedTeam = team\"><div>{{team.name}}</div><div class=small><button class=remove-btn ng-click=\"$event.stopPropagation(); vm.removeFavorite(\'team\', team._id)\"><span class=icon-trash></span> Remove</button></div></li></ul><h5 ng-if=\"vm.data[vm.ui.type].length < 1\">You haven\'t favorited any {{vm.ui.type}}s yet</h5></div><div class=settings-container ng-if=\"vm.ui.page==\'connections\'\"><h2>My Connections</h2><ul class=data-list ng-if=\"vm.ui.type == \'player\' && vm.data.player.length > 0\"><li><div>From</div><div>To</div><div>Type</div><div>Status</div></li><li ng-repeat=\"connection in vm.data.player | orderBy:connection.created:true track by connection._id\" class=actionable ng-click=vm.selectConnection(connection)><div ng-init=\"from = connection.from == main.user.profile.userId ? main.user.profile : connection.fullPlayer\"><div class=user-icon style=\"{{!main.user.isJunior && from.photo ? \'background-image:url(\'+ vm.ui.api + from.photo +\')\' : \'\'}}\"><span ng-if=\"main.user.isJunior || !from.photo\">{{from.fname[0]}}</span></div>{{connection.from == main.user.profile.userId ? \'Me\' : from.fname}} <span ng-if=\"connection.fromTeam && connection.team && connection.fullTeam\">/ {{connection.fullTeam.name}}</span></div><div ng-init=\"to = connection.to == main.user.profile.userId ? main.user.profile : connection.fullPlayer\"><div class=user-icon style=\"{{!main.user.isJunior && to.photo ? \'background-image:url(\'+ vm.ui.api + to.photo +\')\' : \'\'}}\"><span ng-if=\"main.user.isJunior || !to.photo\">{{to.fname[0]}}</span></div>{{connection.to == main.user.profile.userId ? \'Me\' : to.fname}} <span ng-if=\"!connection.fromTeam && connection.team && connection.fullTeam\">/ {{connection.fullTeam.name}}</span></div><div><span class=type-tag>{{connection.type == \'hit\' ? \'Someone to hit with\' : \'Team Play\'}}</span></div><div><span class=\"status-icon {{connection.status}}\"></span> <span class=desktop-only>{{connection.status}} - {{connection.updated ? connection.updated : connection.created | date:\'MMM d, yyyy h:mm a\'}}</span></div></li></ul><h5 ng-if=\"vm.data[vm.ui.type].length < 1\">You haven\'t made any {{vm.ui.type}} connections yet</h5></div>");
$templateCache.put("app/settings/settings.html","<!-- Overlay --><div class=overlay ng-if=\"vm.ui.edit.profile || vm.ui.edit.contact || vm.ui.edit.tennis || vm.ui.editTeamProfile || vm.ui.showNewTeam || vm.ui.showNewTeamProfile || vm.ui.editTeam || vm.ui.uploadPhoto\"><div class=overlay-content><button class=close-btn ng-click=\"vm.ui.edit.profile=vm.ui.edit.contact=vm.ui.edit.tennis=vm.ui.showNewTeam=vm.ui.showNewTeamProfile=vm.ui.newTeam=vm.ui.editTeamProfile=vm.ui.editTeam=vm.ui.uploadPhoto=false\"><span class=icon-x></span></button><!-- Upload Photo --><div ng-if=vm.ui.uploadPhoto><h2>Upload a profile photo</h2><input class=upload-file type=file id=profile-photo file-input file-model=vm.ui.newProfilePhoto accept=image/*><label class=upload-label for=profile-photo>{{vm.ui.newProfilePhoto ? vm.ui.newProfilePhoto.name : \'Select\'}}</label><div class=error ng-if=vm.ui.uploadError>There was an error uploading your photo, please try again.</div><button class=green-btn ng-click=vm.saveProfilePhoto() ng-disabled=!vm.ui.newProfilePhoto>Save</button></div><!-- New Team --><div ng-if=vm.ui.newTeam><h2>Create a Team Looking for Players</h2><h3>Name</h3><input type=text ng-model=vm.ui.newTeam.name><h3>Facility</h3><input type=text ng-model=vm.ui.newTeam.facility><h3>Facility Zip Code</h3><input type=text ng-model=vm.ui.newTeam.facilityZip placeholder=\"5 digit zip code...\" ng-minlength=5 ng-maxlength=5 ng-pattern=/^[0-9]*$/ ><div class=error ng-if=!vm.ui.newTeam.facilityZip>Please enter a valid zip code</div><h3>League</h3><dropdown model=vm.ui.newTeam.league options=vm.ui.appDefaults.leagues[main.user.settings.agePreference] placeholder=\"Select League...\"></dropdown><h3>Playing Level</h3><dropdown model=vm.ui.newTeam.level options=vm.ui.appDefaults.altaLevels[main.user.settings.agePreference] placeholder=\"Select Playing Level...\"></dropdown><h3>Team Type</h3><dropdown model=vm.ui.newTeam.type options=vm.ui.appDefaults.teamTypes[main.user.settings.agePreference] placeholder=\"Select Team Type...\"></dropdown><h3>County</h3><dropdown model=vm.ui.newTeam.county options=vm.ui.appDefaults.counties placeholder=\"Select your County...\"></dropdown><h3>Season</h3><dropdown model=vm.ui.newTeam.season options=vm.ui.appDefaults.availableSeasons placeholder=\"Select your Season...\"></dropdown><h3>About</h3><textarea type=text ng-model=vm.ui.newTeam.about placeholder=\"About the team...\" maxlength=250></textarea><div class=error ng-if=vm.ui.teamError>There was an error creating your team, please try again.</div><div class=button-group><button class=cancel-btn ng-click=\"vm.ui.newTeam=vm.ui.showNewTeam=false\">Cancel</button> <button class=save-btn ng-click=vm.saveNewTeam() ng-disabled=\"vm.ui.newTeam.name.length < 2 || vm.ui.newTeam.facility.length < 2 || !vm.ui.newTeam.facilityZip || !vm.ui.newTeam.league || !vm.ui.newTeam.type || !vm.ui.newTeam.level || !vm.ui.newTeam.county || !vm.ui.newTeam.season\">Create</button></div></div><!-- New Team Profile --><div ng-if=vm.ui.newTeamProfile><h2>Create a Find a Team Request</h2><h3>Name this profile</h3><input type=text ng-model=vm.ui.newTeamProfile.name><h3>League</h3><dropdown model=vm.ui.newTeamProfile.league options=vm.ui.appDefaults.leagues[main.user.settings.agePreference] placeholder=\"Select League...\"></dropdown><h3>Playing Level</h3><dropdown model=vm.ui.newTeamProfile.level options=vm.ui.appDefaults.altaLevels[main.user.settings.agePreference] placeholder=\"Select Playing Level...\"></dropdown><h3>Team Type</h3><dropdown model=vm.ui.newTeamProfile.type options=vm.ui.appDefaults.teamTypes[main.user.settings.agePreference] placeholder=\"Select Team Type...\"></dropdown><h3>County</h3><dropdown model=vm.ui.newTeamProfile.county options=vm.ui.appDefaults.counties placeholder=\"Select your County...\"></dropdown><h3>Zip Code</h3><input type=text ng-model=vm.ui.newTeamProfile.zip placeholder=\"5 digit zip code...\" ng-minlength=5 ng-maxlength=5 ng-pattern=/^[0-9]*$/ ><div class=error ng-if=!vm.ui.newTeamProfile.zip>Please enter a valid zip code</div><h3>About</h3><textarea type=text ng-model=vm.ui.newTeamProfile.about placeholder=\"Describe what you\'re looking for in a team you\'d play for...\" maxlength=250></textarea><div class=error ng-if=vm.ui.teamError>There was an error creating your team profile, please try again.</div><div class=button-group><button class=cancel-btn ng-click=\"vm.ui.newTeamProfile=vm.ui.showNewTeamProfile=false\">Cancel</button> <button class=save-btn ng-click=vm.saveNewTeamProfile() ng-disabled=\"vm.ui.newTeamProfile.name.length < 2 || !vm.ui.newTeamProfile.zip || !vm.ui.newTeamProfile.league || !vm.ui.newTeamProfile.type || !vm.ui.newTeamProfile.level || !vm.ui.newTeamProfile.county\">Create</button></div></div><!-- Edit Team --><div ng-if=vm.ui.editTeam><h2>Edit: <strong>{{vm.ui.editTeam.name}}</strong></h2><h6>Created {{vm.ui.editTeam.created | date:\'longDate\'}} <i ng-if=vm.ui.editTeam.updated>, Updated {{vm.ui.editTeam.updated | date:\'longDate\'}}</i></h6><h6>Auto-Expires <strong>{{vm.ui.editTeam.expires | date:\'longDate\'}}</strong></h6><button class=delete-btn ng-click=vm.deleteTeam()>Delete Team</button><h3>Name</h3><input type=text ng-model=vm.ui.editTeam.name><h3>Facility</h3><input type=text ng-model=vm.ui.editTeam.facility><h3>Facility Zip Code</h3><input type=text ng-model=vm.ui.editTeam.facilityZip placeholder=\"5 digit zip code...\" ng-minlength=5 ng-maxlength=5 ng-pattern=/^[0-9]*$/ ><div class=error ng-if=!vm.ui.editTeam.facilityZip>Please enter a valid zip code</div><h3>League</h3><dropdown model=vm.ui.editTeam.league options=vm.ui.appDefaults.leagues[main.user.settings.agePreference] placeholder=\"Select League...\"></dropdown><h3>Playing Level</h3><dropdown model=vm.ui.editTeam.level options=vm.ui.appDefaults.altaLevels[main.user.settings.agePreference] placeholder=\"Select Playing Level...\"></dropdown><h3>Team Type</h3><dropdown model=vm.ui.editTeam.type options=vm.ui.appDefaults.teamTypes[main.user.settings.agePreference] placeholder=\"Select Team Type...\"></dropdown><h3>County</h3><dropdown model=vm.ui.editTeam.county options=vm.ui.appDefaults.counties placeholder=\"Select your County...\"></dropdown><h3>Season</h3><dropdown model=vm.ui.editTeam.season options=vm.ui.appDefaults.availableSeasons placeholder=\"Select your Season...\"></dropdown><h3>About</h3><textarea type=text ng-model=vm.ui.editTeam.about placeholder=\"About the team...\" maxlength=250></textarea><div class=error ng-if=vm.ui.teamError>There was an error updating your team, please try again.</div><div class=button-group><button class=cancel-btn ng-click=\"vm.ui.editTeam=false\">Cancel</button> <button class=save-btn ng-click=vm.saveTeamUpdates() ng-disabled=\"vm.ui.editTeam.name.length < 2 || vm.ui.editTeam.facility.length < 2 || !vm.ui.editTeam.facilityZip || !vm.ui.editTeam.league || !vm.ui.editTeam.type || !vm.ui.editTeam.level || !vm.ui.editTeam.county || !vm.ui.editTeam.season\">Save</button></div></div><!-- Edit Team Profile --><div ng-if=vm.ui.editTeamProfile><h2>Edit: <strong>{{vm.ui.editTeamProfile.name}}</strong></h2><h6>Created {{vm.ui.editTeamProfile.created | date:\'longDate\'}} <i ng-if=vm.ui.editTeamProfile.updated>, Updated {{vm.ui.editTeamProfile.updated | date:\'longDate\'}}</i></h6><button class=delete-btn ng-click=vm.deleteTeamProfile()>Delete Profile</button><h3>Name</h3><input type=text ng-model=vm.ui.editTeamProfile.name><h3>League</h3><dropdown model=vm.ui.editTeamProfile.league options=vm.ui.appDefaults.leagues[main.user.settings.agePreference] placeholder=\"Select League...\"></dropdown><h3>Playing Level</h3><dropdown model=vm.ui.editTeamProfile.level options=vm.ui.appDefaults.altaLevels[main.user.settings.agePreference] placeholder=\"Select Playing Level...\"></dropdown><h3>Team Type</h3><dropdown model=vm.ui.editTeamProfile.type options=vm.ui.appDefaults.teamTypes[main.user.settings.agePreference] placeholder=\"Select Team Type...\"></dropdown><h3>County</h3><dropdown model=vm.ui.editTeamProfile.county options=vm.ui.appDefaults.counties placeholder=\"Select your County...\"></dropdown><h3>Zip Code</h3><input type=text ng-model=vm.ui.editTeamProfile.zip placeholder=\"5 digit zip code...\" ng-minlength=5 ng-maxlength=5 ng-pattern=/^[0-9]*$/ ><div class=error ng-if=!vm.ui.editTeamProfile.zip>Please enter a valid zip code</div><h3>About</h3><textarea type=text ng-model=vm.ui.editTeamProfile.about placeholder=\"Describe what you\'re looking for in a team you\'d play for...\" maxlength=250></textarea><div class=error ng-if=vm.ui.teamError>There was an error updating your team profile, please try again.</div><div class=button-group><button class=cancel-btn ng-click=\"vm.ui.editTeamProfile=false\">Cancel</button> <button class=save-btn ng-click=vm.saveTeamProfileUpdates() ng-disabled=\"vm.ui.editTeamProfile.name.length < 2 || !vm.ui.editTeamProfile.zip || !vm.ui.editTeamProfile.league || !vm.ui.editTeamProfile.type || !vm.ui.editTeamProfile.level || !vm.ui.editTeamProfile.county\">Save</button></div></div><!-- Profile --><div ng-if=vm.ui.edit.profile><h2>Edit Profile</h2><h3>First Name</h3><input type=text ng-model=vm.ui.editCopy.profile.fname><h3>Last Name</h3><input type=text ng-model=vm.ui.editCopy.profile.lname><h3>About me</h3><textarea type=text ng-model=vm.ui.editCopy.profile.about placeholder=\"About me...\" maxlength=250></textarea><div class=button-group><button class=cancel-btn ng-click=\"vm.ui.edit.profile=false\">Cancel</button> <button class=save-btn ng-click=vm.saveUpdates() ng-disabled=\"vm.ui.editCopy.profile.fname.length < 2 || vm.ui.editCopy.profile.lname.length < 2\">Save</button></div></div><!-- Contact --><div ng-if=vm.ui.edit.contact><h2>Edit Contact Preferences</h2><h3>County</h3><dropdown model=vm.ui.editCopy.profile.county options=vm.ui.appDefaults.counties placeholder=\"Select a county...\"></dropdown><h3>Zip Code</h3><input type=text ng-model=vm.ui.editCopy.profile.zip placeholder=\"5 digit zip code...\" ng-minlength=5 ng-maxlength=5 ng-pattern=/^[0-9]*$/ ><div class=error ng-if=!vm.ui.editCopy.profile.zip>Please enter a valid zip code</div><h3>Phone Number</h3><phone-directive name=phone model=vm.ui.editCopy.profile.phone is-valid=vm.ui.validPhone></phone-directive><div class=error ng-if=!vm.ui.validPhone>Please enter a valid phone number</div><h3>Preferred Contact Method</h3><dropdown model=vm.ui.editCopy.settings.preferredContact options=\"[\'Email\', \'Phone\']\" placeholder=\"Select your Preferred contact method...\"></dropdown><h3>Notification Methods</h3><ul class=multi-picker><li class=\"selected disabled\">App: You\'ll always receive notifications within this application</li><li ng-class=\"{selected: vm.ui.editCopy.settings.notificationMethods.email}\" ng-click=\"vm.toggleNotifs(\'email\')\">Email: We\'ll also dispatch notifications to your email address</li><li ng-class=\"{selected: vm.ui.editCopy.settings.notificationMethods.phone}\" ng-click=\"vm.toggleNotifs(\'phone\')\">Phone: We\'ll also dispatch notifications via text to your phone number</li></ul><div class=button-group><button class=cancel-btn ng-click=\"vm.ui.edit.contact=false\">Cancel</button> <button class=save-btn ng-click=vm.saveUpdates() ng-disabled=\"!vm.ui.editCopy.profile.county || !vm.ui.editCopy.profile.zip || !vm.ui.validPhone\">Save</button></div></div><!-- Tennis / Pref --><div ng-if=vm.ui.edit.tennis><h2>Edit Tennis History / Preferences</h2><h3>USTA #</h3><input type=text ng-model=vm.ui.editCopy.settings.ustaNumber placeholder=\"Enter your USTA #...\"><h3>USTA Level</h3><dropdown model=vm.ui.editCopy.settings.ustaLevel options=\"main.user.isJunior ? vm.ui.appDefaults.altaLevels.junior : vm.ui.appDefaults.altaLevels.junior.concat(vm.ui.appDefaults.altaLevels.adult)\" placeholder=\"Select your Playing Level...\"></dropdown><h3>ALTA Level</h3><input type=text ng-model=vm.ui.editCopy.settings.altaLevel placeholder=\"Enter your ALTA Level...\"><h3>Preferred Match Type</h3><dropdown model=vm.ui.editCopy.settings.matchType options=vm.ui.appDefaults.matchTypes placeholder=\"Select your Preferred Match Type...\"></dropdown><h3>Preferred Side</h3><dropdown model=vm.ui.editCopy.settings.matchSide options=vm.ui.appDefaults.matchSides placeholder=\"Select your Preferred Side...\"></dropdown><h3>Are you willing to captain?</h3><dropdown model=vm.ui.editCopy.settings.captain options=\"[\'Yes\',\'No\']\" placeholder=\"Select yes or no...\"></dropdown><div class=button-group><button class=cancel-btn ng-click=\"vm.ui.edit.tennis=false\">Cancel</button> <button class=save-btn ng-click=vm.saveUpdates()>Save</button></div></div></div></div><div class=settings-container><h2>Account</h2><ul class=tabbar><li ng-class=\"{selected: vm.ui.tab==\'settings\'}\" ng-click=\"vm.ui.tab=\'settings\'\">Settings</li><li ng-class=\"{selected: vm.ui.tab==\'play\'}\" ng-click=\"vm.ui.tab=\'play\'\">Teams & Play</li></ul><button class=green-btn ui-sref=feed()>Start finding players/teams now</button><br><!-- Teams/Play --><div ng-if=\"vm.ui.tab==\'play\'\"><div ng-if=\"main.user.profile.discoverable && main.user.profile.discoverable != \'No\'\"><h3>Teams I\'m Looking For</h3><h6>This will help team managers learn what types of teams you\'d like to play on</h6><div class=content-container><button class=green-btn ng-click=vm.setupNewTeamProfile()>Create a Find a Team Request</button><ul class=data-list ng-if=\"main.user.profile.teamProfiles.length > 0\"><li><div>Profile</div><div class=desktop-only>Type/League</div><div class=desktop-only>Playing Level</div><div class=desktop-only>County / ZIP</div><div>Actions</div></li><li ng-repeat=\"profile in main.user.profile.teamProfiles track by profile.profileId\"><div>{{profile.name}}</div><div class=desktop-only>{{profile.type}} / {{profile.league}}</div><div class=desktop-only>{{profile.level}}</div><div class=desktop-only>{{profile.county}} / {{profile.zip}}</div><div><button class=gray-btn ng-click=vm.editTeamProfile(profile)>Edit</button></div></li></ul><h5 ng-if=\"main.user.profile.teamProfiles.length < 1\">You haven\'t created any team profiles yet</h5></div></div><h3>My Teams</h3><div class=content-container><button class=green-btn ng-click=vm.setupNewTeam()>Create a Team Looking for Players</button><ul class=data-list ng-if=\"main.user.teams.length > 0\"><li><div>Name</div><div class=desktop-only>Facility</div><div class=desktop-only>Type/League</div><div class=desktop-only>Playing Level</div><div class=desktop-only>County / ZIP</div><div class=desktop-only>Season</div><div>Actions</div></li><li ng-repeat=\"team in main.user.teams track by team._id\"><div>{{team.name}}</div><div class=desktop-only>{{team.facility}}</div><div class=desktop-only>{{team.type}} / {{team.league}}</div><div class=desktop-only>{{team.level}}</div><div class=desktop-only>{{team.county}} / {{team.facilityZip}}</div><div class=desktop-only>{{team.season}}</div><div><button class=gray-btn ng-click=vm.editTeam(team)>Edit</button></div></li></ul><h5 ng-if=\"main.user.teams.length < 1\">You haven\'t created any teams yet</h5></div><h3>Play</h3><div class=content-container><div class=flex-container><div class=flex-left>Allow me to be discovered by teams looking for players <span ng-if=\"main.user.profile.discoverable && main.user.profile.discoverable != \'No\'\"><br>Auto-Expires on {{main.user.profile.discoverableExpires | date:\'longDate\'}}.</span> <button class=less-btn ng-if=\"main.user.profile.discoverable && main.user.profile.discoverable != \'No\'\" ng-click=vm.toggleDiscoverable(main.user.profile.discoverable)>Renew now</button></div><div class=flex-right ng-class=\"{highlight: main.user.profile.discoverable && main.user.profile.discoverable != \'No\'}\"><dropdown model=main.user.profile.discoverable change=vm.toggleDiscoverable options=\"[\'No\', \'Winter\', \'Spring\', \'Summer\', \'Fall\']\" placeholder=Select...></dropdown></div></div></div><div class=content-container><div class=flex-container><div class=flex-left>Allow me to be discovered by players looking for players to hit with</div><div class=flex-right><div class=toggle-switch ng-class=\"{selected: main.user.profile.hitWith}\" ng-click=vm.toggleHitWith()></div></div></div></div></div><!-- Settings --><div ng-if=\"vm.ui.tab==\'settings\'\"><h3>Profile</h3><div class=content-container><div class=flex-container><div class=\"flex-left floated\"><div class=\"big-user-icon float\" ng-class=\"{actionable: !main.user.isJunior}\" ng-click=\"vm.ui.uploadPhoto=true\" style=\"{{main.user.profile.photo ? \'background-image:url(\' + vm.ui.api + main.user.profile.photo + \')\' : \'\'}}\"><span ng-if=!main.user.profile.photo>{{main.user.profile.fname[0]}}{{main.user.profile.lname[0]}}</span></div><div class=\"info-bucket float\"><h3>{{main.user.profile.fname}} {{main.user.profile.lname}}</h3><p class=highlighted>{{main.user.profile.about ? main.user.profile.about : \'No about me just yet...\'}}</p><p>My birthday: <strong>{{main.user.profile.dob | date:\'longDate\'}}</strong></p><p><i>Last updated <strong ng-if=!main.user.profile.lastUpdated>{{main.user.profile.created | date:\'longDate\'}}</strong><strong ng-if=main.user.profile.lastUpdated>{{main.user.profile.lastUpdated | date:\'longDate\'}}</strong></i></p></div></div><div class=flex-right><button class=gray-btn ng-click=\"vm.edit(\'profile\')\">Edit</button></div></div></div><h3>Contact Preferences</h3><div class=content-container><div class=flex-container><div class=flex-left><div class=info-bucket><h3>County: <strong>{{main.user.profile.county ? main.user.profile.county : \'Not specified\'}}</strong></h3><h3>Zip Code: <strong>{{main.user.profile.zip ? main.user.profile.zip : \'Not specified\'}}</strong></h3><h3>Phone Number: <strong>{{main.user.profile.phone | phoneNumberFilter}}</strong></h3><h3>Preferred Contact Method: <strong>{{main.user.settings.preferredContact ? main.user.settings.preferredContact : \'Email\'}}</strong></h3><h3>Notification Methods: <span class=tag>app</span><span class=tag ng-if=\"main.user.settings.notificationMethods && method!=\'app\'\" ng-repeat=\"(method,key) in main.user.settings.notificationMethods\">{{method}}</span></h3></div></div><div class=flex-right><button class=gray-btn ng-click=\"vm.edit(\'contact\')\">Edit</button></div></div></div><h3>Tennis History / Preferences</h3><div class=content-container><div class=flex-container><div class=flex-left><div class=info-bucket><h3>USTA #: <a ng-if=main.user.settings.ustaNumber target=_blank href={{vm.ui.appDefaults.ustaProfile.adult}}{{main.user.settings.ustaNumber}}>{{main.user.settings.ustaNumber}}</a><strong ng-if=!main.user.settings.ustaNumber>Not specified</strong></h3><h3>USTA Level: <strong>{{main.user.settings.ustaLevel ? main.user.settings.ustaLevel : \'Not specified\'}}</strong></h3><h3>ALTA Level: <strong>{{main.user.settings.altaLevel ? main.user.settings.altaLevel : \'Not specified\'}}</strong></h3><h3>Preferred Match Type: <strong>{{main.user.settings.matchType ? main.user.settings.matchType : \'Not specified\'}}</strong></h3><h3>Preferred Side: <strong>{{main.user.settings.matchSide ? main.user.settings.matchSide : \'Not specified\'}}</strong></h3><h3>Willing to captain? <strong>{{main.user.settings.captain ? main.user.settings.captain : \'Not specified\'}}</strong></h3></div></div><div class=flex-right><button class=gray-btn ng-click=\"vm.edit(\'tennis\')\">Edit</button></div></div></div></div></div>");}]);